import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  NgZone,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { ResultComponent } from '../result/result.component';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatInput, MatInputModule } from '@angular/material/input';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatRadioModule } from '@angular/material/radio';
import { CommonModule, NgClass, NgFor, NgIf } from '@angular/common';

import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { MatSelect, MatSelectModule } from '@angular/material/select';
import { MatTooltip } from '@angular/material/tooltip';
import { MatToolbarModule } from '@angular/material/toolbar';
import { TextFieldModule } from '@angular/cdk/text-field';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';
//import { ResultComponent } from '../result/result.component';
import { FooterComponent } from '../../../widgets/footer/footer.component';
import { Router } from '@angular/router';
import { SelectionModel } from '@angular/cdk/collections';
import { SubstantiationPopupComponent } from './substantiation-popup/substantiation-popup.component';
import { HomeService } from '../home/home.service';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { ClaimsReviewPopupComponent } from './claims-review-popup/claims-review-popup.component';
import { SubstantiationService } from './substantiation-service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { LoadingService } from '../../../services/loading.service';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { TooltipComponent } from './tooltip/tooltip.component';
import { SharedService } from '../../../services/shared.service';
import { PopupType } from '../../../widgets/app-popup/app-popup.component';
import { IraAlertPopupComponent } from '../../../widgets/ira-alert-popup/ira-alert-popup.component';
import { IraResultService } from '../../ira-result/ira-result.service';
import { ClickOutsideDirective } from '../../../directives/app-click-outside.directive';
import { Safe } from '../../../pipes/safeHtml.pipe';
import {
  CdkDragDrop,
  DragDropModule,
  moveItemInArray,
} from '@angular/cdk/drag-drop';
import { EditorModule, TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';
import { PreviewService } from '../preview/preview.service';
import { Converters } from '../../../static/converters';
import { debounceTime, Subject } from 'rxjs';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'app-substantiation',
  standalone: true,
  templateUrl: './substantiation.component.html',
  styleUrl: './substantiation.component.scss',
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition(
        'expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')
      ),
    ]),
  ],
  //standalone: true,
  imports: [
    MatTableModule,
    MatButton,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    NgFor,
    NgClass,
    MatTooltip,
    MatToolbarModule,
    MatIconModule,
    MatInput,
    MatInputModule,
    FormsModule,
    MatSelectModule,
    NgIf,
    TextFieldModule,
    MatMenuTrigger,
    CommonModule,
    //ResultComponent,
    FooterComponent,
    MatRadioModule,
    ScrollingModule,
    ClickOutsideDirective,
    Safe,
    DragDropModule,
    EditorModule,
    ToastModule,
  ],
  providers: [
    MessageService,
    { provide: TINYMCE_SCRIPT_SRC, useValue: 'tinymce/tinymce.min.js' },
  ],
})
export class SubstantiationComponent {
  displayedColumns = [
    'checkbox',
    'slno',
    'text',
    'qualifier',
    'marketing_channels',
    'support_strategy',
    'substantiations',
    'icon',
    'expand',
  ];
  // Use these in your table header rendering
  tableHeaders = {
    local: {
      text: 'Statement Text',
      qualifier: 'Qualifier',
    },
    global: {
      text: 'Global Statement Text',
      qualifier: 'Global Qualifier',
    },
  };
  displayedColumns1: any = [
    'checkbox',
    'substantiation_id',
    'description',
    'substantiation_details',
    'geography',
    'subtype',
    'document_link',
    // 'action',
  ];
  public rowIndex: any;
  private editIndex: any = null;
  disclaimerIndex: any = null;
  editItem: any;
  editableReport: any;
  originalReport: any;
  private isReportChanged = false;
  eeocDocId: any;
  enableDropdowns: boolean = false;
  selection = new SelectionModel<PeriodicElement>(true, []);

  options_marketing: string[] = [];
  searchTerm: string;
  showStatementSearch: boolean = false;
  showQualifierSearch: boolean = false;
  substantiationIdSearch: boolean = false;
  descriptionSearch: boolean = false;
  projectValue: any;
  productValue: any;
  geographyValue: any;
  originalData: PeriodicElement[] = [];
  showMarketingFilter: boolean = false;
  showGeographyFilter: boolean = false;
  marketingChannelFilter = new FormControl([]);
  originalElements: any[] = []; // Store original data
  filteredElements: any[] = [];
  substantiationtextFilter = new FormControl('');
  resultsData: any;
  totalValue: any;
  routeData: any;
  initialData: any;
  expandedElement: any | null;
  expandcol = false;

  showTranlsationGroup = false;
  showLanguageGroup = false;
  geographyData: any = [];
  languagesData: any = [];
  relatedStatementChecked: boolean = false;
  backtranslationChecked: boolean = false;
  radioBtnValue: string;
  languageDisabled: boolean = false;
  defaultLanguageDisbaled: boolean = true;
  showSupportGroup: boolean = true;
  //isTruncated = true;
  tableRows: any[] = [];
  tableRowsRaw: any[] = [];
  filterTextValue: any;
  selectedLanguage: any;
  // marketingChannels: any = [];
  // selectedMarketingChannels: any = [];
  toggleValue: 'local' | 'global' = 'local';
  textFilter = new FormControl('');
  qualifierFilter = new FormControl('');
  // marketingFilter = new FormControl('');

  marketingFilter = new FormControl<string[]>([], { nonNullable: true });

  lifecycleFilter = new FormControl([]);
  // expand table form control
  substantiationIdFilter = new FormControl('');
  substantiationdescFilter = new FormControl('');
  substantiationGeogeaphyFilter = new FormControl('');

  filterValues = {
    text: '',
    qualifier: '',
    marketing_channels: [],
  };
  newDataSource = new MatTableDataSource<any>([]);
  isTextEditor = new Array(this.newDataSource.data.length).fill(false);
  expandedElements: Set<string> = new Set();
  expandedDataMap: Map<string, any[]> = new Map(); // row => API response array
  expandedFilterMap: Map<any, any[]> = new Map(); // for expand table
  selectedGeography: string = '';
  // expand table filter
  expandedRowFilters: Map<
    any,
    {
      substantiationId: FormControl;
      description: FormControl;
      geography: FormControl;
    }
  > = new Map();
  expandedRowSearchState: Map<
    any,
    {
      substantiationId: boolean;
      description: boolean;
      geography: boolean;
    }
  > = new Map();
  public autoSaveSubject = new Subject<void>();
  @Input() selectedView: 'local' | 'global' = 'local';
  @Output() selectedChange = new EventEmitter<'local' | 'global'>();
  @ViewChild('tableContainer') tableContainer!: ElementRef;
  @ViewChild('marketingDropdown') marketingDropdown!: MatSelect;
  @ViewChild('geographyDropdown') geographyDropdown!: MatSelect;
  @Input() isRowVisible: boolean = false;
  @Input() isTruncated: boolean = true;
  @Input() resultnewDataSource;
  @Input() resultexistingDataSource;
  @Input() new_qualifier;
  @Input() routeSource;
  @Input() saveDraftData;
  @Input() routeFrom;
  @Input() fileDetailsSub;

  @Output() sendDataToResult = new EventEmitter<any>();

  //@Input() isFormatted: boolean = false; // Flag to indicate if the text is formatted
  // delete func
  @ViewChild('deleteSubstDialog') deleteSubstDialog: TemplateRef<any>;
  substToDelete: any = null;
  dialogRef: any = null;
  deleteElement: any = null;
  deleteIndex: number = null;
  completetabledata: any;
  isFormatted: boolean = false;
  @Input() draftData: any;
  @Input() docData: any;
  // Add these two properties to store view-specific data
  localDataSource: any[] = [];
  globalDataSource: any[] = [];
  selectedSubstantiataionRow: any = [];
  @Output() disableIra = new EventEmitter<boolean>();

  private overlayRef: OverlayRef | null = null;
  private destroy$ = new Subject<void>(); // Add destroy subject
  constructor(
    private cdr: ChangeDetectorRef,
    private router: Router,
    private dialog: MatDialog,
    private homeService: HomeService,
    private substantiationService: SubstantiationService,
    private ngZone: NgZone,
    public loadingService: LoadingService,
    private overlay: Overlay,
    private vcr: ViewContainerRef,
    public sharedService: SharedService,
    public iraResultService: IraResultService,
    public previewService: PreviewService,
    private messageService: MessageService,
    private sanitizer: DomSanitizer
  ) {}
  checkdatachaged: any;
  claimsToReview = []; // Initialize array to store claims with flg: true

  // saved session varibale
  isSavesession = false;

  savedSessionResponse: any[] = [];
  ngOnInit() {
    if (
      this.routeFrom === 'editClaims' ||
      localStorage.getItem('routeFromSubConf') === 'editClaims'
    ) {
      this.disableIra.emit(true);
    }
    // Example: in ngOnInit or before navigation
    this.iraResultService.setiraConfirmChanges(false);
    console.log(this.fileDetailsSub, 'fileDetailsSub bbb');
    console.log(this.docData, 'Document datat');
    console.log(localStorage.getItem('geography'), 'before befoe');
    // if (localStorage.getItem('geography')) {
    //   localStorage.removeItem('substantiationToggle');
    // }
    //console.log(localStorage.removeItem('substantiationToggle'), 'after');
    const savedToggle = localStorage.getItem('substantiationToggle');
    // if (savedToggle === 'local' || savedToggle === 'global') {
    //   this.selectedView = savedToggle as 'local' | 'global';
    // }
    const geography = localStorage.getItem('geography');
    if (geography && (savedToggle === 'local' || savedToggle === 'global')) {
      this.selectedView = savedToggle as 'local' | 'global';
    } else {
      this.selectedView = 'local';
    }
    console.log(this.routeSource, 'draft');
    if (this.routeSource == 'substantiation-Draft') {
      this.isSavesession = true;
    }
    console.log(this.isSavesession, 'isSavesession');
    // trigger save draft function after 30 seconds when change in input
    this.autoSaveSubject.pipe(debounceTime(30000)).subscribe(() => {
      console.log(this.saveDraftData, 'aaa'),
        this.saveDraftSubstantiation(this.saveDraftData);
    });
    let originalData: any[] = [];
    this.substantiationService.isFormatted$.subscribe((value) => {
      this.isFormatted = value;
    });
    //to fetch All markting channle
    //this.getMarketingChannels(); // Fetch marketing channels on component load

    this.selectedGeography = localStorage.getItem('geography');
    this.completetabledata = [
      ...this.resultexistingDataSource,
      ...this.resultnewDataSource,
    ];
    console.log(this.new_qualifier, 'new_qualifier');
    this.selectedLanguage = localStorage.getItem('language');
    this.loadingService.setLoading(true);

    console.log(this.routeFrom, 'from result route');

    // Payload to get the table detaials
    const data = {
      session_id: sessionStorage.getItem('sessionId'),
      environment: localStorage.getItem('environment'),
      product_id: localStorage.getItem('product') || 'V18000000066002',
      project_id: localStorage.getItem('project'),
      geography_id: localStorage.getItem('geography') || '',

      ...(this.isSavesession && {
        //user_id: 'suhana.s@unilever.com',
        user_id: localStorage.getItem('userId') || '',
        savedraft_data: 'yes',
        page:
          this.routeFrom === 'editClaims' ? 'Sub_editclaims' : 'Substantiation',
      }),
      user_role: localStorage.getItem('userRole'),
      buisness_group: localStorage.getItem('businessGroup'),
      //buisness_group: 'beauty_wellbeing_bg__c',
      user_security_profile: localStorage.getItem('userRole'),

      // user_id: 'suhana.s@unilever.com',
      // savedraft_data: 'yes',
      //claims_la: this.completetabledata,
    };
    console.log(data, 'payload data for getclaimsubsup');
    this.claimsToReview = [];
    const isLocal = this.selectedView === 'local';
    const statementKey = isLocal ? 'statement' : 'global_statement';
    const qualifierKey = isLocal ? 'qualifier' : 'global_qualifier';
    this.substantiationService.getSupportStrategyTableDetails(data).subscribe({
      next: (data) => {
        // Store original data before processing

        console.log(data, 'data from substantiation service');
        this.checkdatachaged = data;
        // After mapping, store the data in the correct view-specific array
        if (isLocal) {
          this.localDataSource = this.tableRowsRaw.map((row) => ({ ...row }));
        } else {
          this.globalDataSource = this.tableRowsRaw.map((row) => ({ ...row }));
        }

        // Set the table to show only the current view’s data
        this.newDataSource.data = isLocal
          ? [...this.localDataSource]
          : [...this.globalDataSource];
        // const statementKey =
        //   this.selectedView === 'local' ? 'statement' : 'global_statement';
        // const qualifierKey =
        //   this.selectedView === 'local' ? 'qualifier' : 'global_qualifier';

        // add saved session check

        if (this.isSavesession) {
          console.log('Data from save session back button');
          this.tableRowsRaw = data.map((claim, idx) => {
            console.log(claim, 'claim from saved if');
            if (claim.flg === true && claim.savedraft_data) {
              this.claimsToReview.push(claim.savedraft_data);
            }
            claim.claimReviewData = claim.new_claim_data;

            // Map user added substantiations with correct color coding
            const userAddedSubs = (claim._userAddedSubstantiations || []).map(
              (sub) => {
                const isUserAdded = true;
                const hasGeography = !!this.selectedGeography;
                if (isUserAdded && hasGeography) {
                  sub.textColorClass = 'text-dark-blue';
                } else if (isUserAdded && !hasGeography) {
                  //sub.textColorClass = 'text-dark-grey';
                  sub.textColorClass = 'text-dark-blue';
                }
                sub._preserveTextColor = true;
                console.log(sub, 'subbb');
                return this.mapSubstantiation(sub, true);
              }
            );

            // Map API substantiations (not user added) with color coding
            const apiSubs = (claim.apiSubstantiations || []).map((sub) => {
              const isUserAdded = false;
              const hasGeography = !!this.selectedGeography;
              if (!isUserAdded && hasGeography) {
                // sub.textColorClass = 'text-light-blue';
                sub.textColorClass = 'text-blue';
              } else if (!isUserAdded && !hasGeography) {
                //sub.textColorClass = 'text-grey';
                sub.textColorClass = 'text-blue';
              }
              return this.mapSubstantiation(sub, false);
            });

            // Merge and dedupe by substantiation_id
            const substMap = new Map();
            [...apiSubs, ...userAddedSubs].forEach((sub) => {
              if (sub && sub.substantiation_id)
                substMap.set(sub.substantiation_id, sub);
            });
            const allSubstantiations = Array.from(substMap.values());

            return {
              slno: claim.slno || (idx + 1).toString().padStart(2, '0'),
              text: claim.statement || '',
              originalText: claim.originalText || claim.statement || '',
              qualifier: claim.qualifier || [],
              originalQualifier: claim.originalQualifier || [],
              marketing_channels: claim.marketing_channels || [],
              support_strategy: claim.support_strategy_rich || '',
              originalSupportStrategy:
                claim.originalSupportStrategy ||
                claim.support_strategy_rich ||
                '',
              substantiations: allSubstantiations,
              substantiationsString: allSubstantiations
                .map((x) => x.name)
                .join(','),
              expandedData: claim.expandedData || [],
              rowType: claim.rowType || '',
              _userAddedSubstantiations: userAddedSubs,
              apiSubstantiations: apiSubs,
              originalSubstantiations: allSubstantiations,
              master_exist: claim.master_exist ?? false,
              project_exist: claim.project_exist ?? false,
              claim_la_name: claim.claim_la_name,
              claim_la_bid: claim.claim_la_bid,
              claim_la_id: claim.claim_la_id || '',
              originalMarketingChannels: claim.originalMarketingChannels || [],
              review_claim: claim.flg,
              savedraft_data: claim.savedraft_data || [],
              claimReviewData: claim.claimReviewData || claim.new_claim_data,
              isSupportStrategyEdited: false,
              wasInWrapMode: false,
              editing_permission: claim.editing_permission,
              claim_la_state_ui: claim.claim_la_state_ui,
              substantiation_permission: claim.substantiation_permission,
              globalText: claim.globalText ?? '',
              globalQualifier: Array.isArray(claim.globalQualifier)
                ? claim.globalQualifier.filter((q) => !!q)
                : [],
              selected: true,
              //selected: !!claim.selected,
            };
          });
          console.log(
            this.tableRowsRaw,
            'this.tableRowsRaw from saved session'
          );

          this.tableRows = this.getTableRows();
          // only those marketing channels which is comes in API
          const allChannels = this.tableRowsRaw
            .flatMap((row) => row.marketing_channels)
            .filter(Boolean);
          this.options_marketing = Array.from(new Set(allChannels));
          console.log(this.options_marketing, 'this.options_marketing');
          this.newDataSource.data = this.tableRowsRaw;
          this.checkdatachaged = JSON.parse(JSON.stringify(this.tableRowsRaw));
          this.selection.select(...this.newDataSource.data);
          // ...rest of your filter setup and subscriptions...
          //return; // Skip the rest of ngOnInit for saved session
        } else if (!this.isSavesession && this.draftData) {
          console.log('data  from draft');
          console.log(this.draftData, 'draftData from result');

          // Assign tableRowsRaw using the same logic as isSavesession
          this.tableRowsRaw = this.draftData.map((claim, idx) => {
            if (claim.flg === true && claim.savedraft_data) {
              this.claimsToReview.push(claim.savedraft_data);
            }
            claim.claimReviewData = claim.new_claim_data;

            // Map user added substantiations with correct color coding
            const userAddedSubs = (claim._userAddedSubstantiations || []).map(
              (sub) => {
                const isUserAdded = true;
                const hasGeography = !!this.selectedGeography;
                sub.textColorClass = 'text-dark-blue';
                sub._preserveTextColor = true;
                return this.mapSubstantiation(sub, true);
              }
            );

            // Map API substantiations (not user added) with color coding
            const apiSubs = (claim.apiSubstantiations || []).map((sub) => {
              sub.textColorClass = 'text-blue';
              return this.mapSubstantiation(sub, false);
            });

            // Merge and dedupe by substantiation_id
            const substMap = new Map();
            [...apiSubs, ...userAddedSubs].forEach((sub) => {
              if (sub && sub.substantiation_id)
                substMap.set(sub.substantiation_id, sub);
            });
            const allSubstantiations = Array.from(substMap.values());

            return {
              slno: claim.slno || (idx + 1).toString().padStart(2, '0'),
              text: claim.text || '',
              originalText: claim.originalText || claim.text || '',
              qualifier: claim.qualifier || [],
              originalQualifier: claim.originalQualifier || [],
              marketing_channels: claim.marketing_channels || [],
              support_strategy:
                claim.support_strategy_rich || claim.support_strategy || '',
              originalSupportStrategy:
                claim.originalSupportStrategy || claim.support_strategy || '',
              substantiations: allSubstantiations,
              substantiationsString: allSubstantiations
                .map((x) => x.name)
                .join(','),
              expandedData: claim.expandedData || [],
              rowType: claim.rowType || '',
              _userAddedSubstantiations: userAddedSubs,
              apiSubstantiations: apiSubs,
              originalSubstantiations: allSubstantiations,
              master_exist: claim.master_exist ?? false,
              project_exist: claim.project_exist ?? false,
              claim_la_name: claim.claim_la_name,
              claim_la_bid: claim.claim_la_bid,
              claim_la_id: claim.claim_la_id || '',
              originalMarketingChannels: claim.originalMarketingChannels || [],
              review_claim: claim.flg,
              savedraft_data: claim.savedraft_data || [],
              claimReviewData: claim.new_claim_data,
              isSupportStrategyEdited: false,
              wasInWrapMode: false,
              editing_permission: claim.editing_permission,
              claim_la_state_ui: claim.claim_la_state_ui,
              substantiation_permission: claim.substantiation_permission,
              globalText: claim.globalText ?? '',
              globalQualifier: Array.isArray(claim.globalQualifier)
                ? claim.globalQualifier.filter((q) => !!q)
                : [],
              selected: claim.selected,
              //selected: claim.selected ? claim.selected : false,
            };
          });

          this.tableRows = this.getTableRows();
          // only those marketing channels which is comes in API
          const allChannels = this.tableRowsRaw
            .flatMap((row) => row.marketing_channels)
            .filter(Boolean);
          this.options_marketing = Array.from(new Set(allChannels));
          console.log(this.options_marketing, 'this.options_marketing');
          this.newDataSource.data = this.tableRowsRaw;
          this.newDataSource.filter = '';
          console.log(this.newDataSource.data, 'from draft version');
          this.checkdatachaged = JSON.parse(JSON.stringify(this.tableRowsRaw));
          this.selection.clear();
          this.newDataSource.data.forEach((row) => {
            if (row.selected === true) {
              this.selection.select(row);
            }
          });
          // // this.selection.select(...this.newDataSource.data);

          // // Sync SelectionModel with selected property
          // this.selection.clear();
          // this.newDataSource.data.forEach((row) => {
          //   if (row.selected) {
          //     console.log(row, 'rowss');
          //     this.selection.select(row);
          //   }
          // });
          // this.tableRows = this.getTableRows();

          //return; // <--- Prevent API call and rest of ngOnInit
        } else if (!this.isSavesession && !this.draftData) {
          console.log(' Data from API substantiation');
          this.tableRowsRaw = data.map((claim, idx) => {
            if (claim.flg === true && claim.savedraft_data) {
              this.claimsToReview.push(claim.savedraft_data); // Store for later use
            }

            const slno = (idx + 1).toString().padStart(2, '0');

            // new Logic
            const claimSubstNames = new Set(
              (claim.claim_substantiations || []).map(
                (sub) => sub['substantiation__vr.name__v']
              )
            );

            const seenIds = new Set<string>();

            const mappedSubstantiations = (claim.substantiations || [])
              .map((sub) =>
                this.mapSubstantiation(
                  {
                    ...sub,
                    substantiation_link: sub['substantiation_link'],
                    description: sub['substantiation__vr.description__v'] || '',
                    name: sub['substantiation__vr.name__v'] || '',
                    substantiation_details:
                      sub['substantiation__vr.substantiation_details__c'] ||
                      null,
                    geography: sub['country__cr.name__v'] || '',
                    subtype: sub['related_reference__vr.subtype__v'] || '',
                    fromClaimSubst: claimSubstNames.has(
                      sub['substantiation__vr.name__v']
                    ),
                  },
                  false
                )
              )
              .filter((sub) => {
                if (seenIds.has(sub.substantiation_id)) return false;
                seenIds.add(sub.substantiation_id);
                return true;
              });

            return {
              slno,
              // text: claim.statement || '',
              // originalText: claim.statement || '',

              text: claim[statementKey] || '',
              originalText: claim[statementKey] || '',

              // qualifier: claim.qualifier ? [claim.qualifier.trim()] : [],
              // originalQualifier: claim.qualifier ? [claim.qualifier.trim()] : [],

              qualifier: claim[qualifierKey]
                ? [claim[qualifierKey].trim()]
                : [],
              originalQualifier: claim[qualifierKey]
                ? [claim[qualifierKey].trim()]
                : [],

              marketing_channels: claim.marketing_channels || [],
              support_strategy: claim.support_strategy_rich || '',
              originalSupportStrategy: claim.support_strategy_rich || '',
              substantiations: mappedSubstantiations,
              substantiationsString: mappedSubstantiations
                .map((sub) => sub.description || '')
                .join(', '),
              expandedData: [],
              rowType: claim.rowType || '',
              _userAddedSubstantiations: [],
              apiSubstantiations: mappedSubstantiations,
              originalSubstantiations: [...mappedSubstantiations], // fallback for non-expanded rows
              master_exist: claim.master_exist ?? false,
              project_exist: claim.project_exist ?? false,
              claim_la_name: claim.claim_la_name,
              claim_la_bid: claim.claim_la_bid,
              claim_la_id: claim.claim_la_id || '',
              originalMarketingChannels: claim.marketing_channels
                ? [...claim.marketing_channels]
                : [],
              review_claim: claim.flg,
              savedraft_data: claim.savedraft_data || [],
              isSupportStrategyEdited: false,
              wasInWrapMode: false,
              editing_permission: claim.editing_permission,
              claim_la_state_ui: claim.claim_la_state_ui,
              substantiation_permission: claim.substantiation_permission,
              globalText: claim.globalText ?? '',
              globalQualifier: Array.isArray(claim.globalQualifier)
                ? claim.globalQualifier.filter((q) => !!q)
                : [],
              selected: claim.selected || true,
              //selected: !!claim.selected,
            };
          });

          this.tableRows = this.getTableRows();

          // only those marketing channels which is comes in API
          const allChannels = this.tableRowsRaw
            .flatMap((row) => row.marketing_channels)
            .filter(Boolean);
          this.options_marketing = Array.from(new Set(allChannels));
          console.log(this.options_marketing, 'this.options_marketing');

          this.loadingService.setLoading(false);
          this.newDataSource.data = this.tableRowsRaw;
          //this.checkdatachaged = this.tableRowsRaw;
          this.checkdatachaged = JSON.parse(JSON.stringify(this.tableRowsRaw));
          console.log(this.checkdatachaged, 'ng on intoriginalData');
          this.selection.select(...this.newDataSource.data);

          // this.selection.clear();
          // this.newDataSource.data.forEach((row) => {
          //   if (row.selected === true) {
          //     this.selection.select(row);
          //   }
          // });
        }
        // // Assign originalData after processing the API response
        // originalData = [...this.newDataSource.data];

        // // Compare original data with updated data
        // const changedRows = this.newDataSource.data.filter((row, index) => {
        //   const originalRow = originalData[index];
        //   return Object.keys(row).some((key) => {
        //     return row[key] !== originalRow[key];
        //   });
        // });

        //console.log('Changed Rows:', changedRows);

        // console.log('Changed Rows:', changedRows); // Log changed rows
        this.newDataSource.filterPredicate = (
          data: any,
          filter: string
        ): boolean => {
          const searchTerms = JSON.parse(filter);

          const textMatch =
            !searchTerms.text ||
            data.text.toLowerCase().includes(searchTerms.text.toLowerCase());

          const qualifierMatch =
            !searchTerms.qualifier ||
            (Array.isArray(data.qualifier)
              ? data.qualifier
                  .join(' ')
                  .toLowerCase()
                  .includes(searchTerms.qualifier.toLowerCase())
              : (data.qualifier || '')
                  .toLowerCase()
                  .includes(searchTerms.qualifier.toLowerCase()));

          const marketingMatch =
            !searchTerms.marketing_channels.length ||
            (data.marketing_channels || []).some((channel: string) =>
              searchTerms.marketing_channels.includes(channel)
            );

          return textMatch && qualifierMatch && marketingMatch;
        };

        this.newDataSource.filter = JSON.stringify(this.filterValues);
        this.tableRows = this.getTableRows();
        //this.selection.select(...this.newDataSource.data);
      },
      error: (err) => {
        this.loadingService.setLoading(false);
      },
    });

    this.newDataSource.data.forEach((row) => {
      if (row.selected == true) {
        console.log(row, 'inside roww');
        this.selection.select(row);
      }
      row.originalMarketingChannels = [...row.marketing_channels];
      row.originalText = row.text;
      row.qualifier = row.originalQualifier;
      // Save originalQualifier as either an array or a string
      // row.originalQualifier = Array.isArray(row.qualifier)
      //   ? [...row.qualifier] // Copy the array
      //   : row.qualifier || ''; // Assign the string or default to an empty string

      // console.log(row.originalQualifier, 'from ngOnInit row.originalQualifier');

      row.support_strategy = row.originalSupportStrategy || '';
      // Reset substantiations to original
      row.substantiations = [...row.originalSubstantiations];
      row.apiSubstantiations = [...row.originalSubstantiations];
      row._userAddedSubstantiations = [];
      row.substantiationsString = row.originalSubstantiations
        .map((s: any) => s.description || '')
        .join(', ');
      this.expandedDataMap.set(row, [...row.originalSubstantiations]);
    });

    this.textFilter.valueChanges.subscribe((val) => {
      this.filterValues.text = val || '';
      this.newDataSource.filter = JSON.stringify(this.filterValues);
      this.tableRows = this.getTableRows();
    });
    this.qualifierFilter.valueChanges.subscribe((val) => {
      this.filterValues.qualifier = val || '';
      this.newDataSource.filter = JSON.stringify(this.filterValues);
      this.tableRows = this.getTableRows();
    });
    this.marketingFilter.valueChanges.subscribe((val) => {
      this.filterValues.marketing_channels = val || ([] as any);
      this.newDataSource.filter = JSON.stringify(this.filterValues);
      this.tableRows = this.getTableRows();
    });

    this.newDataSource.data = this.newDataSource.data.map((item) => ({
      ...item,
      originalText: item.text,
      text: item.text,
      isEdited: false,
      showIcons: false,
    }));

    //expand table filter logic
    this.substantiationIdFilter.valueChanges.subscribe(() =>
      this.applyAllExpandedFilters()
    );
    this.substantiationdescFilter.valueChanges.subscribe(() =>
      this.applyAllExpandedFilters()
    );
    this.substantiationGeogeaphyFilter.valueChanges.subscribe(() =>
      this.applyAllExpandedFilters()
    );
  }

  // getSanitizedContent(content: string): SafeHtml {
  //   return this.sanitizer.bypassSecurityTrustHtml(content);
  // }

  selected: any;

  // ngOnChanges(changes: SimpleChanges): void {
  //   if (changes['selectedView'] && !changes['selectedView'].firstChange) {
  //     // Save current edits to the correct view-specific array
  //     if (changes['selectedView'].previousValue === 'local') {
  //       this.localDataSource = this.newDataSource.data.map((row) => ({
  //         ...row,
  //       }));
  //     } else {
  //       this.globalDataSource = this.newDataSource.data.map((row) => ({
  //         ...row,
  //       }));
  //     }

  //     // Always call API on toggle
  //     const data = {
  //       session_id: sessionStorage.getItem('sessionId'),
  //       environment: localStorage.getItem('environment'),
  //       product_id: localStorage.getItem('product') || 'V18000000066002',
  //       project_id: localStorage.getItem('project'),
  //       geography_id: localStorage.getItem('geography') || '',
  //       user_role: localStorage.getItem('userRole'),
  //       buisness_group: localStorage.getItem('businessGroup'),
  //       user_security_profile: localStorage.getItem('userRole'),
  //       // add other required fields
  //     };

  //     if (this.selectedView === 'local') {
  //       this.substantiationService
  //         .getSupportStrategyTableDetails(data)
  //         .subscribe({
  //           next: (apiData) => {
  //             // Map API data
  //             let newRows = apiData.map((claim, idx) => ({
  //               slno: claim.slno || (idx + 1).toString().padStart(2, '0'),
  //               text: claim.statement || '',
  //               originalText: claim.statement || '',
  //               qualifier: claim.qualifier ? [claim.qualifier.trim()] : [],
  //               originalQualifier: claim.qualifier
  //                 ? [claim.qualifier.trim()]
  //                 : [],
  //               marketing_channels: claim.marketing_channels || [],
  //               support_strategy: claim.support_strategy_rich || '',
  //               originalSupportStrategy: claim.support_strategy_rich || '',
  //               substantiations: (claim.substantiations || []).map((sub) =>
  //                 this.mapSubstantiation(sub, false)
  //               ),
  //               substantiationsString: (claim.substantiations || [])
  //                 .map((sub) => sub.description || '')
  //                 .join(', '),
  //               expandedData: [],
  //               rowType: claim.rowType || '',
  //               _userAddedSubstantiations: [],
  //               apiSubstantiations: (claim.substantiations || []).map((sub) =>
  //                 this.mapSubstantiation(sub, false)
  //               ),
  //               originalSubstantiations: (claim.substantiations || []).map(
  //                 (sub) => this.mapSubstantiation(sub, false)
  //               ),
  //               master_exist: claim.master_exist ?? false,
  //               project_exist: claim.project_exist ?? false,
  //               claim_id: claim.claim_la_name,
  //               claim_la_id: claim.claim_la_bid,
  //               originalMarketingChannels: claim.marketing_channels
  //                 ? [...claim.marketing_channels]
  //                 : [],
  //               review_claim: claim.flg,
  //               savedraft_data: claim.savedraft_data || [],
  //               isSupportStrategyEdited: false,
  //               editing_permission: claim.editing_permission,
  //               claim_la_state_ui: claim.claim_la_state_ui,
  //             }));

  //             // Merge any previous edits
  //             if (this.localDataSource.length > 0) {
  //               newRows = newRows.map((row) => {
  //                 const edited = this.localDataSource.find(
  //                   (r) => r.slno === row.slno
  //                 );
  //                 return edited ? { ...row, ...edited } : row;
  //               });
  //             }

  //             this.localDataSource = [...newRows];
  //             this.newDataSource.data = [...this.localDataSource];
  //             this.tableRows = this.getTableRows();
  //             this.selection.clear();
  //             this.selection.select(...this.newDataSource.data);
  //             this.cdr.detectChanges();
  //           },
  //           error: () => {
  //             this.loadingService.setLoading(false);
  //           },
  //         });
  //     } else if (this.selectedView === 'global') {
  //       this.substantiationService
  //         .getSupportStrategyTableDetails(data)
  //         .subscribe({
  //           next: (apiData) => {
  //             // Map API data
  //             let newRows = apiData.map((claim, idx) => ({
  //               slno: claim.slno || (idx + 1).toString().padStart(2, '0'),
  //               text: claim.global_statement || '',
  //               originalText: claim.global_statement || '',
  //               qualifier: claim.global_qualifier
  //                 ? [claim.global_qualifier.trim()]
  //                 : [],
  //               originalQualifier: claim.global_qualifier
  //                 ? [claim.global_qualifier.trim()]
  //                 : [],
  //               marketing_channels: claim.marketing_channels || [],
  //               support_strategy: claim.support_strategy_rich || '',
  //               originalSupportStrategy: claim.support_strategy_rich || '',
  //               substantiations: (claim.substantiations || []).map((sub) =>
  //                 this.mapSubstantiation(sub, false)
  //               ),
  //               substantiationsString: (claim.substantiations || [])
  //                 .map((sub) => sub.description || '')
  //                 .join(', '),
  //               expandedData: [],
  //               rowType: claim.rowType || '',
  //               _userAddedSubstantiations: [],
  //               apiSubstantiations: (claim.substantiations || []).map((sub) =>
  //                 this.mapSubstantiation(sub, false)
  //               ),
  //               originalSubstantiations: (claim.substantiations || []).map(
  //                 (sub) => this.mapSubstantiation(sub, false)
  //               ),
  //               master_exist: claim.master_exist ?? false,
  //               project_exist: claim.project_exist ?? false,
  //               claim_id: claim.claim_la_name,
  //               claim_la_id: claim.claim_la_bid,
  //               originalMarketingChannels: claim.marketing_channels
  //                 ? [...claim.marketing_channels]
  //                 : [],
  //               review_claim: claim.flg,
  //               savedraft_data: claim.savedraft_data || [],
  //               isSupportStrategyEdited: false,
  //               editing_permission: claim.editing_permission,
  //               claim_la_state_ui: claim.claim_la_state_ui,
  //             }));

  //             // Merge any previous edits
  //             if (this.globalDataSource.length > 0) {
  //               newRows = newRows.map((row) => {
  //                 const edited = this.globalDataSource.find(
  //                   (r) => r.slno === row.slno
  //                 );
  //                 return edited ? { ...row, ...edited } : row;
  //               });
  //             }

  //             this.globalDataSource = [...newRows];
  //             this.newDataSource.data = [...this.globalDataSource];
  //             this.tableRows = this.getTableRows();
  //             this.selection.clear();
  //             this.selection.select(...this.newDataSource.data);
  //             this.cdr.detectChanges();
  //           },
  //           error: () => {
  //             this.loadingService.setLoading(false);
  //           },
  //         });
  //     }
  //   }
  // }
  // ngOnChanges(changes: SimpleChanges): void {
  //   if (changes['selectedView'] && !changes['selectedView'].firstChange) {
  //     // Save current edits to the correct view-specific array
  //     if (changes['selectedView'].previousValue === 'local') {
  //       this.localDataSource = this.newDataSource.data.map((row) => ({
  //         ...row,
  //       }));
  //     } else {
  //       this.globalDataSource = this.newDataSource.data.map((row) => ({
  //         ...row,
  //       }));
  //     }

  //     // Always call API on toggle
  //     const data = {
  //       session_id: sessionStorage.getItem('sessionId'),
  //       environment: localStorage.getItem('environment'),
  //       product_id: localStorage.getItem('product') || 'V18000000066002',
  //       project_id: localStorage.getItem('project'),
  //       geography_id: localStorage.getItem('geography') || '',
  //       user_role: localStorage.getItem('userRole'),
  //       buisness_group: localStorage.getItem('businessGroup'),
  //       user_security_profile: localStorage.getItem('userRole'),
  //     };

  //     const isLocal = this.selectedView === 'local';
  //     const statementKey = isLocal ? 'statement' : 'global_statement';
  //     const qualifierKey = isLocal ? 'qualifier' : 'global_qualifier';

  //     this.substantiationService
  //       .getSupportStrategyTableDetails(data)
  //       .subscribe({
  //         next: (apiData) => {
  //           // Only update text and qualifier/originalQualifier, keep all other fields as is
  //           this.newDataSource.data = this.newDataSource.data.map(
  //             (row, idx) => {
  //               const apiRow = apiData.find(
  //                 (api, apiIdx) =>
  //                   api.slno === row.slno ||
  //                   (api.slno == null && idx === apiIdx) // fallback if slno missing
  //               );
  //               if (apiRow) {
  //                 return {
  //                   ...row,
  //                   text: apiRow[statementKey] || '',
  //                   originalText: apiRow[statementKey] || '',
  //                   qualifier: apiRow[qualifierKey]
  //                     ? [apiRow[qualifierKey].trim()]
  //                     : [],
  //                   originalQualifier: apiRow[qualifierKey]
  //                     ? [apiRow[qualifierKey].trim()]
  //                     : [],
  //                 };
  //               }
  //               return row;
  //             }
  //           );

  //           // Update view-specific data source for future toggles
  //           if (isLocal) {
  //             this.localDataSource = [...this.newDataSource.data];
  //           } else {
  //             this.globalDataSource = [...this.newDataSource.data];
  //           }

  //           this.tableRows = this.getTableRows();
  //           this.selection.clear();
  //           this.selection.select(...this.newDataSource.data);
  //           this.cdr.detectChanges();
  //         },
  //         error: () => {
  //           this.loadingService.setLoading(false);
  //         },
  //       });
  //   }
  // }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedView'] && !changes['selectedView'].firstChange) {
      // Save current edits to the correct view-specific array
      if (changes['selectedView'].previousValue === 'local') {
        this.localDataSource = this.newDataSource.data.map((row) => ({
          ...row,
        }));
      } else {
        this.globalDataSource = this.newDataSource.data.map((row) => ({
          ...row,
        }));
      }

      // Always call API on toggle
      const data = {
        session_id: sessionStorage.getItem('sessionId'),
        environment: localStorage.getItem('environment'),
        product_id: localStorage.getItem('product') || 'V18000000066002',
        project_id: localStorage.getItem('project'),
        geography_id: localStorage.getItem('geography') || '',
        user_role: localStorage.getItem('userRole'),
        buisness_group: localStorage.getItem('businessGroup'),
        user_security_profile: localStorage.getItem('userRole'),
      };

      this.substantiationService
        .getSupportStrategyTableDetails(data)
        .subscribe({
          next: (apiData) => {
            this.newDataSource.data = this.newDataSource.data.map(
              (row, idx) => {
                const apiRow = apiData.find(
                  (api, apiIdx) =>
                    api.slno === row.slno ||
                    (api.slno == null && idx === apiIdx)
                );
                if (apiRow) {
                  // Always keep both local/global values in new fields
                  const localText = apiRow['statement'] || '';
                  const localQualifier = apiRow['qualifier']
                    ? [apiRow['qualifier'].trim()]
                    : [];
                  const globalText = apiRow['global_statement'] || '';
                  const globalQualifier = apiRow['global_qualifier']
                    ? [apiRow['global_qualifier'].trim()]
                    : [];

                  // Save local in text/qualifier, global in globalText/globalQualifier
                  return {
                    ...row,
                    text: localText,
                    qualifier: localQualifier,
                    globalText: globalText,
                    globalQualifier: globalQualifier,
                  };
                }
                return row;
              }
            );

            // Update view-specific data source for future toggles
            if (this.selectedView === 'local') {
              this.localDataSource = [...this.newDataSource.data];
            } else {
              this.globalDataSource = [...this.newDataSource.data];
            }

            this.tableRows = this.getTableRows();
            this.selection.clear();
            this.selection.select(...this.newDataSource.data);
            this.cdr.detectChanges();
          },
          error: () => {
            this.loadingService.setLoading(false);
          },
        });
    }
  }

  loadDraftData(data: any) {
    console.log(data, 'data coming from sub draft ');
  }

  // updateHeadersAndFilters() {
  //   this.tableHeaders[this.selected].text = this.selected === 'local' ? 'Statement Text' : 'Global Statement Text';
  //   this.tableHeaders[this.selected].qualifier = this.selected === 'local' ? 'Qualifier' : 'Global Qualifier';

  //   this.filterValues.text = '';
  //   this.filterValues.qualifier = '';
  //   this.newDataSource.filter = JSON.stringify(this.filterValues);
  // }

  // enableEditor(element: any, index: number) {
  //   this.substantiationService.triggerEditor(index);
  // }

  /**to sanitize html elements */
  sanitizeHTML(content: string): SafeHtml {
    const div = document.createElement('div');
    div.innerHTML = content;
    return div.textContent || div.innerText || '';
  }

  // filter logic for expaneded Table
  applyAllExpandedFilters() {
    for (const row of this.expandedDataMap.keys()) {
      this.applyExpandedFilters(row);
    }
  }

  marketingChannels: Array<{ marketchannel: string }> = [];
  selectedMarketingChannel: string = ''; // Holds the selected value
  /** Fetch marketing channels from API */

  getMarketingChannels() {
    const payload = {
      session_id: sessionStorage.getItem('sessionId'),
      environment: localStorage.getItem('environment'),
    };
    this.substantiationService
      .getMarketingChannelsubstantiation(payload)
      .subscribe(
        (response: any) => {
          // Validate response and nested text array
          if (response && Array.isArray(response.picklistValues)) {
            this.options_marketing = response.picklistValues.map(
              (channel: { label: string; value: string }) => channel.label
            );
            console.log(this.options_marketing, 'Converted options_marketing');
          } else {
            console.error('Invalid response structure:', response);
            this.options_marketing = []; // Fallback to an empty array
          }
        },
        (error) => {
          console.error('Error fetching marketing channels:', error);
          this.options_marketing = []; // Handle API error gracefully
        }
      );
  }

  applyExpandedFilters(row: any) {
    const all = this.expandedDataMap.get(row) || [];

    const filters = this.expandedRowFilters.get(row);
    if (!filters) {
      this.expandedFilterMap.set(row, all);
      return;
    }
    const idVal = (filters.substantiationId.value || '').toLowerCase();
    const descVal = (filters.description.value || '').toLowerCase();

    let geoVal: string[] = [];
    if (Array.isArray(filters.geography.value)) {
      geoVal = filters.geography.value.map((g: string) => g.toLowerCase());
    } else if (typeof filters.geography.value === 'string') {
      geoVal = [filters.geography.value.toLowerCase()];
    }

    const filtered = all.filter((s: any) => {
      const idMatch =
        !idVal || (s.substantiation_id || '').toLowerCase().includes(idVal);
      const descMatch =
        !descVal || (s.description || '').toLowerCase().includes(descVal);
      const geoMatch =
        !geoVal.length ||
        geoVal.some((val) => (s.geography || '').toLowerCase().includes(val));
      return idMatch && descMatch && geoMatch;
    });

    this.expandedFilterMap.set(row, filtered);
  }

  // selected: 'local' | 'global' = 'local'; // default

  // toggle1() {
  //   this.selected = this.selected === 'local' ? 'global' : 'local';
  //   this.selectedChange.emit(this.selected);
  // }

  // expan table row logic start
  //isExpansionDetailRow = (index: number, row: any) => row.isExpansion === true;
  isExpansionDetailRow = (index: number, row: any) => !!row.isExpansion;
  isNotExpansionDetailRow = (index: number, row: any) => !row.isExpansion;

  mapSubstantiation(s: any, isUserAdded: boolean = false): any {
    //this.autoSaveSubject.next();
    if (!s) return null;
    //console.log(s, 'ss');
    //   if (s._preserveTextColor && s.textColorClass) {
    //   return {
    //     ...s,
    //     isUserAdded,
    //     fromClaimSubst: s.fromClaimSubst === true,
    //   };
    // }

    const fromClaimSubst = !!s.fromClaimSubst;
    const hasGeography = !!this.selectedGeography;
    let textColorClass = s.textColorClass;
    // console.log(isUserAdded, 'isUserAdded');
    // console.log(s._preserveTextColor, '_preserveTextColor');

    // Strictly preserve color for user-added substantiations with _preserveTextColor
    if (isUserAdded && s._preserveTextColor) {
      textColorClass = s.textColorClass;
    } else if (!textColorClass) {
      if (isUserAdded && hasGeography) {
        // for LA flow when user added substantion from popup
        textColorClass = 'text-dark-blue';
      } else if (isUserAdded && !hasGeography) {
        // for Claim flow when user added substantion from popup
        //textColorClass = 'text-dark-grey';
        textColorClass = 'text-dark-blue';
      } else if (!isUserAdded && fromClaimSubst) {
        // for LA flow when substantion is part of claim and LA
        // textColorClass = 'text-grey';
        textColorClass = 'text-black';
      } else if (!isUserAdded && !fromClaimSubst && hasGeography) {
        // for LA flow of  substantion coming from API
        // textColorClass = 'text-light-blue';
        textColorClass = 'text-blue';
      } else if (!isUserAdded && !fromClaimSubst && !hasGeography) {
        // for Claim flow of  substantion coming from API
        // textColorClass = 'text-grey';
        textColorClass = 'text-blue';
      } else {
        // default blue
        //textColorClass = 'text-grey'; // fallback
        textColorClass = 'text-blue';
      }
    }

    return {
      name:
        s.name ||
        s.substantiation_name ||
        s.substantiationId ||
        s.substantiation_id ||
        '',
      description:
        s.description ||
        s.substantiation_description ||
        s.details ||
        s.substantiation_details ||
        '',
      details: s.details || s.substantiation_details || '',
      substantiation_details:
        s.substantiationDetails || s.substantiation_details || s.details || '',
      substantiation_id:
        s.substantiation_id ||
        s.substantiationId ||
        s.name ||
        s['substantiation__vr.name__v'] ||
        s.id ||
        '',
      link: s.substantiation_link || s.document_link || '',
      substantiation_link: s.substantiation_link || '',
      document_link: s.document_link || s.documentLink || '',
      support_strategy: s.support_strategy || '',
      document_name:
        s['related_reference__vr.name__v'] ||
        s.documentName ||
        s.doc_name ||
        s.document_name ||
        '',
      geography: s['country__cr.name__v'] || s.geography || '',
      subtype:
        s.subtype || s.subType || s['related_reference__vr.subtype__v'] || '',
      isUserAdded,
      fromClaimSubst,
      textColorClass,
    };
  }

  // updateRowSubstantiations(row: any): void {
  //   //this.autoSaveSubject.next();
  //   const deletedIds = new Set(row._deletedSubstantiationIds || []);

  //   // Use originalSubstantiations if apiSubstantiations is not available
  //   const api = (
  //     row.apiSubstantiations?.length
  //       ? row.apiSubstantiations
  //       : row.originalSubstantiations || []
  //   )
  //     .map((sub) => this.mapSubstantiation(sub, false))
  //     .filter((sub) => !deletedIds.has(sub.substantiation_id));

  //   // const user = (row._userAddedSubstantiations || [])
  //   //   .map((sub) => this.mapSubstantiation(sub, true))
  //   //   .filter((sub) => !deletedIds.has(sub.substantiation_id));

  //   const user = (row._userAddedSubstantiations || [])
  //     .map((sub) => {
  //       console.log('Mapping user-added substantiation:', sub);
  //       // Always preserve textColorClass for user-added substantiations
  //       const mapped = this.mapSubstantiation(sub, true);
  //       if (sub.textColorClass) {
  //         mapped.textColorClass = sub.textColorClass;
  //       }
  //       mapped.substantiation_details =
  //         sub.substantiation_details || sub.details || '';
  //       mapped.geography = sub.geography || sub['country__cr.name__v'] || '';
  //       // Mark as user-added for further logic if needed
  //       mapped.isUserAdded = true;
  //       return mapped;
  //     })
  //     .filter((sub) => !deletedIds.has(sub.substantiation_id));

  //   const substMap = new Map<string, any>();
  //   [...api, ...user].forEach((sub) => {
  //     const id = sub.substantiation_id;
  //     const existing = substMap.get(id);
  //     if (!existing || sub.isUserAdded) {
  //       substMap.set(id, sub);
  //     }
  //   });

  //   const all = Array.from(substMap.values());
  //   row.substantiations = all;
  //   row.substantiationsString = all.map((x) => x.name).join(',');
  //   this.expandedDataMap.set(row, all);
  // }

  updateRowSubstantiations(row: any): void {
    const deletedIds = new Set(row._deletedSubstantiationIds || []);

    const api = (
      row.apiSubstantiations?.length
        ? row.apiSubstantiations
        : row.originalSubstantiations || []
    )
      .map((sub) => this.mapSubstantiation(sub, false))
      .filter((sub) => !deletedIds.has(sub.substantiation_id));

    // Build a lookup for API substantiations by ID
    const apiMap = new Map<string, any>();
    api.forEach((sub) => apiMap.set(sub.substantiation_id, sub));

    const user = (row._userAddedSubstantiations || [])
      .map((sub) => {
        const mapped = this.mapSubstantiation(sub, true);
        if (sub.textColorClass) {
          mapped.textColorClass = sub.textColorClass;
        }
        // If user-added substantiation is missing details/geography, fallback to API
        const apiSub = apiMap.get(mapped.substantiation_id);
        mapped.substantiation_details =
          mapped.substantiation_details ||
          apiSub?.substantiation_details ||
          mapped.details ||
          apiSub?.details ||
          '';
        mapped.geography = mapped.geography || apiSub?.geography || '';
        mapped.details = mapped.details || apiSub?.details || '';
        mapped.isUserAdded = true;
        return mapped;
      })
      .filter((sub) => !deletedIds.has(sub.substantiation_id));

    // Always prefer user-added substantiations for duplicate IDs
    const substMap = new Map<string, any>();
    api.forEach((sub) => {
      substMap.set(sub.substantiation_id, sub);
    });
    user.forEach((sub) => {
      substMap.set(sub.substantiation_id, sub);
    });

    const all = Array.from(substMap.values());
    row.substantiations = all;
    row.substantiationsString = all.map((x) => x.name).join(',');
    this.expandedDataMap.set(row, all);
  }

  dedupeSubstantiations(subs: any[]): any[] {
    return Array.from(
      new Map((subs || []).map((s) => [s.name.trim(), s])).values()
    );
  }

  assignSubstantiationsToRow(row: any, selectedSubstantiations: any[]) {
    this.autoSaveSubject.next(); // Resets the timer
    if (!row._userAddedSubstantiations) {
      row._userAddedSubstantiations = [];
    }

    // Ensure substantiations are up-to-date before checking
    this.updateRowSubstantiations(row);

    // Collect all substantiation IDs already shown
    const existingIds = new Set(
      (row.substantiations || []).map((s: any) => s.substantiation_id)
    );

    for (const sub of selectedSubstantiations) {
      // const mapped = this.mapSubstantiation(sub, true);
      const mapped = this.mapSubstantiation(
        {
          ...sub,
          substantiation_details:
            sub.substantiation_details || sub.details || '',
          geography: sub.geography || sub['country__cr.name__v'] || '',
          fromClaimSubst: sub.fromClaimSubst ?? false,
        },
        true
      );

      if (mapped && mapped.substantiation_id) {
        if (existingIds.has(mapped.substantiation_id)) {
          console.log(
            `Duplicate substantiation skipped: ${mapped.substantiation_id}`
          );
          continue;
        }
        row._userAddedSubstantiations.push(mapped);
      }
    }

    // Rebuild substantiations with all data preserved
    this.updateRowSubstantiations(row);

    // Always update expandedDataMap regardless of expansion state
    this.expandedDataMap.set(row, row.substantiations);

    if (this.expandedElements.has(row)) {
      this.applyExpandedFilters(row);
    }

    this.tableRows = this.getTableRows();
    this.cdr.detectChanges();
  }

  // Declare a variable to store geography options
  geographyOptions: string[] = [];
  // Declare a map to store geography options for each row
  rowGeographyOptions: { [key: string]: string[] } = {};
  /** Expansion logic for rows */

  Rowexpandandcollapse(row: any, index: number) {
    console.log(row, 'row from expand and collapse');

    const key = row.data;

    // Always preserve textColorClass for user-added substantiations before updating
    if (
      row._userAddedSubstantiations &&
      Array.isArray(row._userAddedSubstantiations)
    ) {
      row._userAddedSubstantiations.forEach((sub) => {
        sub._preserveTextColor = true;
      });
    }

    // If already expanded, collapse
    if (this.expandedElements.has(row)) {
      this.expandedElements.delete(row);
      this.tableRows = this.getTableRows();
      this.cdr.detectChanges();
      return;
    }

    const substNames = this.dedupeSubstantiations([
      ...(row.substantiations || []),
      ...(row._userAddedSubstantiations || []),
    ])
      .filter((s) => s.name && String(s.name).trim() !== '')
      .map((s) => s.name);

    // Check if substantiations have changed since last fetch
    const lastFetched = row.lastFetchedSubstantiations || [];
    const unchanged =
      substNames.length === lastFetched.length &&
      substNames.every((v, i) => v === lastFetched[i]);

    if (
      unchanged &&
      row.apiSubstantiations &&
      row.apiSubstantiations.length > 0
    ) {
      // Use cached data, just expand
      this.updateRowSubstantiations(row);
      this.expandedElements.add(row);
      this.tableRows = this.getTableRows();
      this.cdr.detectChanges();
      return;
    }

    // Compute claimSubstIds before making the API call
    const checksubId = substNames?.filter((name: string) => !!name) || [];

    if (checksubId.length === 0) {
      // If no claimSubstIds, skip API call and expand the row
      this.updateRowSubstantiations(row);
      this.expandedElements.add(row);
      this.tableRows = this.getTableRows();
      this.cdr.detectChanges();
      return;
    }

    this.loadingService.setLoading(true);

    const data = {
      session_id: sessionStorage.getItem('sessionId'),
      environment: localStorage.getItem('environment'),
      substantiations: substNames,
    };

    this.substantiationService.getSubstantiationDetails(data).subscribe({
      next: (response: any) => {
        const substDetailsRaw = response.substantiation_details || [];

        // this.geographyOptions = substDetailsRaw
        //   .map((subst: any) => {
        //     const key = Object.keys(subst)[0]; // Get the first key (e.g., "SUB-225294")
        //     return subst[key]?.['country__cr.name__v']; // Extract the geography value
        //   })
        //   .filter((geo: string | null) => !!geo); // Filter out null or undefined values

        // // Remove duplicates if necessary
        // this.geographyOptions = [...new Set(this.geographyOptions)];

        //const rowId = row; // Ensure this is unique for each row
        const rowId = row.slno;
        console.log(rowId, 'rowId'); // Debugging: Log the row ID

        // Extract geography options for the current row
        const geographyOptions: string[] = substDetailsRaw
          .map((subst: any) => {
            const key = Object.keys(subst)[0]; // Get the first key (e.g., "SUB-225294")
            return subst[key]?.['country__cr.name__v']; // Extract the geography value
          })
          .filter((geo: string | null) => !!geo) as string[]; // Ensure the type is string[]

        console.log(geographyOptions, 'geographyOptions'); // Debugging: Log the extracted options

        // Remove duplicates and assign to rowGeographyOptions
        this.rowGeographyOptions[rowId] = [...new Set(geographyOptions)];
        console.log(this.rowGeographyOptions, 'rowGeographyOptions'); // Debugging: Log the entire options object

        // Ensure the UI is bound to this.rowGeographyOptions[rowId] for the current row

        const claimSubstIds = new Set(
          (row.originalSubstantiations || [])
            .filter((sub) => sub.fromClaimSubst)
            .map((sub) => sub.substantiation_id)
        );

        row.apiSubstantiations = substDetailsRaw.map((entry: any) => {
          const [id, detailRaw] = Object.entries(entry)[0];
          const detail = (detailRaw || {}) as any;
          const detailsValue =
            detail['substantiation_details__c'] ??
            detail.details ??
            detail['substantiation_details'] ??
            '';

          return {
            substantiation_id: id,
            name: detail['name__v'] || id,
            description:
              detail['description__v'] || detail['description'] || '',
            details: detailsValue,
            substantiation_details: detailsValue,
            geography: detail['country__cr.name__v'] || '',
            subtype: detail['related_reference__vr.subtype__v'] || '',
            document_link: detail['document_link'] ?? '',
            link: detail['document_link'] ?? '',
            substantiation_link: detail['substantiation_link'] || '',
            document_name: detail['related_reference__vr.name__v'] || '',
            isUserAdded: false,
            fromClaimSubst: claimSubstIds.has(id), // This preserves the source
          };
        });
        console.log(row.apiSubstantiations, 'apiSubstantiations');
        row.lastFetchedSubstantiations = substNames.slice();

        this.updateRowSubstantiations(row);
        this.expandedElements.add(row);
        if (!this.expandedRowFilters.has(row)) {
          this.expandedRowFilters.set(row, {
            substantiationId: new FormControl(''),
            description: new FormControl(''),
            geography: new FormControl(''),
          });
          // this.expandedRowFilters.set(row.slno, {
          //   substantiationId: new FormControl(''),
          //   description: new FormControl(''),
          //   geography: new FormControl(''),
          // });

          this.expandedRowSearchState.set(row, {
            substantiationId: false,
            description: false,
            geography: false,
          });

          const filters = this.expandedRowFilters.get(row)!;
          filters.substantiationId.valueChanges.subscribe(() =>
            this.applyExpandedFilters(row)
          );
          filters.description.valueChanges.subscribe(() =>
            this.applyExpandedFilters(row)
          );
          filters.geography.valueChanges.subscribe(() =>
            this.applyExpandedFilters(row)
          );
        }
        if (!this.expandedRowSearchState.has(row)) {
          this.expandedRowSearchState.set(row, {
            substantiationId: false,
            description: false,
            geography: false,
          });
        }
        this.applyExpandedFilters(row); // Always filter when expanding
        this.tableRows = this.getTableRows();
        this.cdr.detectChanges();
        this.loadingService.setLoading(false);
      },
      error: () => {
        row.apiSubstantiations = [];
        this.updateRowSubstantiations(row);
        this.expandedElements.add(row);
        this.tableRows = this.getTableRows();
        this.cdr.detectChanges();
        this.loadingService.setLoading(false);
      },
    });
  }

  getTableRows() {
    const rows = [];
    for (let row of this.newDataSource.filteredData) {
      rows.push(row);

      if (this.expandedElements.has(row)) {
        //console.log('Row IS in expandedElements:', row);
        rows.push({ isExpansion: true, data: row });
      } else {
        //console.log('Row NOT in expandedElements:', row);
      }
    }
    return rows;
  }

  openDialog(row: any) {
    const dialogRef = this.dialog.open(SubstantiationPopupComponent, {
      scrollStrategy: this.overlay.scrollStrategies.noop(),
      // width: '90%',
      // height: '100%',
      width: '82.5em',
      height: '38em',
      disableClose: true,
      data: { rowContext: row },
    });

    dialogRef.afterClosed().subscribe((selectedSubstantiations) => {
      console.log(selectedSubstantiations, 'selectedSubstantiations');
      if (selectedSubstantiations && selectedSubstantiations.length > 0) {
        this.assignSubstantiationsToRow(row, selectedSubstantiations);
      }
    });
  }

  get total(): any {
    return this.tableRows[this.totalValue];
  }

  /**to get total level,risk,reason */
  private getTotal(results: any[]): number {
    console.log('results found', results);
    let maxResult;

    const max = results.reduce(function (prev, current) {
      if (+current.level > +prev.level) {
        if (+current.level == +prev.level) {
          if (+current.risk > +prev.risk) {
            return current;
          } else {
            return prev;
          }
        }
        return current;
      } else {
        if (+current.level == +prev.level) {
          if (+current.risk > +prev.risk) {
            return current;
          } else {
            return prev;
          }
        }
        return prev;
      }
    });

    maxResult = results.indexOf(max);

    if (maxResult === -1) {
      return maxResult;
    }
    let maxLevel = +results[maxResult].manual_level;
    let maxRisk = +results[maxResult].manual_risk;
    for (let i = maxResult + 1; i < results.length; i++) {
      if (results[i].isDeleted) {
        continue;
      }
      const level = +results[i].manual_level;
      const risk = +results[i].manual_risk;
      if (level > maxLevel) {
        maxResult = i;
        if (level === 3) {
          return maxResult;
        }
        maxLevel = level;
        maxRisk = risk;
        continue;
      }
      if (maxLevel === 2 && risk > maxRisk) {
        maxResult = i;
        maxLevel = level;
        maxRisk = risk;
      }
    }

    return maxResult;
  }

  // To clear the statement text data in search bar
  clearSearch() {
    this.textFilter.setValue('');
  }

  // To clear the Substantiation Id data in search bar
  clearSubstantiationIdSearch() {
    this.substantiationIdFilter.setValue('');
  }

  // To clear the Qualifier search data in Search bar
  clearQualifierSearch() {
    this.qualifierFilter.setValue('');
  }
  clearMarketingFilterSearch() {
    this.marketingFilter.setValue([]);
  }

  // To clear the Substantiation Id data in search bar
  clearDescriptionSearch() {
    this.substantiationdescFilter.setValue('');
  }

  /**Statement Text Filter */
  applyTextFilter(event: any) {
    this.filterTextValue = event.target.value.trim().toLowerCase();
    this.newDataSource.filter = this.filterTextValue;
  }

  // working as click and unclick for Statement Text search icon
  toggleStatementSearch() {
    this.showStatementSearch = !this.showStatementSearch;
  }

  // working as click and unclick for Substantiation Id search icon
  // toggleSubstantiationIdSearch() {
  //   this.substantiationIdSearch = !this.substantiationIdSearch;
  //   // if (!this.showSearchBox) {
  //   //   this.searchTerm = '';
  //   //   this.filteredElements = [...this.originalElements];
  //   // }
  // }

  toggleSubstantiationIdSearch(row: any) {
    const state = this.expandedRowSearchState.get(row);
    if (state) {
      state.substantiationId = !state.substantiationId;
    }
  }

  // working as click and unclick forDescription search icon
  // toggleDescriptionSearch() {
  //   this.descriptionSearch = !this.descriptionSearch;
  //   // if (!this.showSearchBox) {
  //   //   this.searchTerm = '';
  //   //   this.filteredElements = [...this.originalElements];
  //   // }
  // }

  // Working as click and unclick for Marketing channel filter icon
  // toggleMarketingFilter() {
  //   this.showMarketingFilter = !this.showMarketingFilter;
  //   if (!this.showMarketingFilter) {
  //     this.marketingChannelFilter.setValue([]);
  //   }
  // }
  toggleMarketingFilter() {
    this.showMarketingFilter = !this.showMarketingFilter;

    if (!this.showMarketingFilter) {
      this.marketingChannelFilter.setValue([]);
      // Close the select if it's open
      setTimeout(() => {
        this.marketingDropdown?.close();
      }, 100);
    } else {
      // Ensure the dropdown opens after the view is updated
      this.cdr.detectChanges(); // Trigger change detection
      setTimeout(() => {
        this.marketingDropdown.open(); // Open the dropdown programmatically
      }, 0); // Delay to ensure rendering is complete
    }
  }
  //to close marketing channel select search box when click outside
  onMarketingChannelDropdownClosed() {
    this.showMarketingFilter = false;
  }

  // Working as click and unclick for Marketing channel filter icon
  // toggleGeographyFilter() {
  //   this.showGeographyFilter = !this.showGeographyFilter;
  //   if (!this.showGeographyFilter) {
  //     this.marketingChannelFilter.setValue([]);
  //   }
  // }

  // working as click and unclick for Qualifiier search icon
  toggleQualifierSearch() {
    this.showQualifierSearch = !this.showQualifierSearch;
    // if (!this.showSearchBox) {
    //   this.searchTerm = '';
    //   this.filteredElements = [...this.originalElements];
    // }
  }

  toggleDescriptionSearch(row: any) {
    const state = this.expandedRowSearchState.get(row);
    if (state) {
      state.description = !state.description;
    }
  }
  // toggleGeographyFilter(row: any) {
  //   const state = this.expandedRowSearchState.get(row);
  //   if (state) {
  //     state.geography = !state.geography;

  //   }
  // }

  // toggleGeographyFilter(row: any) {
  //   const state = this.expandedRowSearchState.get(row);
  //   if (state) {
  //     state.geography = !state.geography;

  //     if (!state.geography) {
  //       this.expandedRowFilters.get(row)?.geography.setValue([]);
  //       setTimeout(() => {
  //         this.geographyDropdown?.close();
  //       }, 100);
  //     } else {
  //       this.cdr.detectChanges(); // Ensure view updates
  //       setTimeout(() => {
  //         this.geographyDropdown?.open();
  //       }, 0);
  //     }
  //   }
  // }

  toggleGeographyFilter(row: any) {
    const rowId = row; // Use consistent key
    const state = this.expandedRowSearchState.get(rowId);
    if (state) {
      state.geography = !state.geography;

      if (!state.geography) {
        this.expandedRowFilters.get(rowId)?.geography.setValue([]);
        setTimeout(() => {
          this.geographyDropdown?.close();
        }, 100);
      } else {
        this.cdr.detectChanges(); // Ensure view updates
        setTimeout(() => {
          this.geographyDropdown?.open();
        }, 0);
      }
    }
  }

  onGeographyDropdownClosed(row: any) {
    const state = this.expandedRowSearchState.get(row);
    if (state) {
      state.geography = false;
    }
  }

  // isAllSelected() {
  //   // const numSelected = this.selection.selected.length;
  //   // //const numRows = this.dataSource.data.length;
  //   // const numRows = this.tableRows.length;
  //   // this.selectedSubstantiataionRow = this.selection.selected; // get the selected row data
  //   // return numSelected === numRows;

  //   const selectableRows = this.tableRows.filter((row) => !row.isExpansion);
  //   const numSelected = this.selection.selected.length;
  //   const numRows = selectableRows.length;

  //   // Sync the selected property in newDataSource.data
  //   this.newDataSource.data = this.newDataSource.data.map((row) => ({
  //     ...row,
  //     selected: this.selection.isSelected(row),
  //   }));
  //   return numSelected === numRows && numRows > 0;
  // }

  // isAllSelected() {
  //   const selectableRows = this.tableRows.filter((row) => !row.isExpansion);
  //   const numSelected = selectableRows.filter((row) =>
  //     this.selection.isSelected(row)
  //   ).length;
  //   const numRows = selectableRows.length;
  //   // Sync the selected property in newDataSource.data
  //   this.newDataSource.data = this.newDataSource.data.map((row) => ({
  //     ...row,
  //     selected: this.selection.isSelected(row),
  //   }));
  //   return numRows > 0 && numSelected === numRows;
  // }

  // /** Selects all rows if they are not all selected; otherwise clear selection. */
  // // masterToggle() {
  // //   // if there is a selection then clear that selection
  // //   if (this.isSomeSelected()) {
  // //     this.selection.clear();
  // //   } else {
  // //     this.isAllSelected()
  // //       ? this.selection.clear()
  // //       : this.tableRows.forEach((row) => this.selection.select(row));
  // //   }
  // //   this.selectedSubstantiataionRow = this.selection.selected; // get the selected row data
  // // }

  // masterToggle() {
  //   const selectableRows = this.tableRows.filter((row) => !row.isExpansion);

  //   if (this.isAllSelected()) {
  //     console.log('All rows are selected, clearing selection.');
  //     console.log(this.newDataSource.data,"if")
  //     this.selection.clear();
  //   } else {
  //     console.log('All rows are not slected, clearing selection.');
  //     this.selection.clear();
  //     selectableRows.forEach((row) => this.selection.select(row));
  //     console.log(this.newDataSource.data,"else")
  //   }
  //   this.selectedSubstantiataionRow = this.selection.selected;

  //   // Sync the selected property in newDataSource.data
  //   this.newDataSource.data = this.newDataSource.data.map((row) => ({
  //     ...row,
  //     selected: this.selection.isSelected(row),
  //   }));

  //   this.cdr.detectChanges();
  // }

  // // isSomeSelected() {
  // //   console.log(this.selection.selected);
  // //   return this.selection.selected.length > 0;
  // // }

  // isSomeSelected() {
  //   const selectableRows = this.tableRows.filter((row) => !row.isExpansion);
  //   const numSelected = selectableRows.filter((row) =>
  //     this.selection.isSelected(row)
  //   ).length;
  //   const numRows = selectableRows.length;
  //   return numSelected > 0 && numSelected < numRows;
  // }

  // /** Handles individual checkbox toggle and updates selectedSubstantiataionRow array */
  // toggleRowSelection(row: any) {
  //   this.selection.toggle(row);
  //   row.selected = this.selection.isSelected(row);
  //   this.selectedSubstantiataionRow = this.selection.selected; // Update the selected row data
  //   // Find the actual index in the data source using a unique key
  //   // const index = this.newDataSource.data.findIndex((r) => r.slno === row.slno);
  //   // if (index === -1) return;
  //   // console.log(index, 'index of toggled row');

  //   // this.newDataSource.data[index].selected = !row.selected;

  //   // if (this.newDataSource.data[index].selected) {
  //   //   this.selection.select(row);
  //   // } else {
  //   //   this.selection.deselect(row);
  //   // }
  // }

  // isAllSelected() {
  //   const selectableRows = this.tableRows.filter((row) => !row.isExpansion);
  //   const numSelected = selectableRows.filter((row) =>
  //     this.selection.isSelected(row)
  //   ).length;
  //   const numRows = selectableRows.length;
  //   // Sync selected property in newDataSource.data
  //   this.newDataSource.data = this.newDataSource.data.map((row) => ({
  //     ...row,
  //     selected: this.selection.isSelected(row),
  //   }));
  //   return numRows > 0 && numSelected === numRows;
  // }

  isAllSelected() {
    const selectableRows = this.newDataSource.data.filter(
      (row) => !row.isExpansion
    );
    const numSelected = selectableRows.filter((row) => row.selected).length;
    return selectableRows.length > 0 && numSelected === selectableRows.length;
  }

  // isSomeSelected() {
  //   const selectableRows = this.tableRows.filter((row) => !row.isExpansion);
  //   const numSelected = selectableRows.filter((row) =>
  //     this.selection.isSelected(row)
  //   ).length;
  //   const numRows = selectableRows.length;
  //   return numSelected > 0 && numSelected < numRows;
  // }

  isSomeSelected() {
    const selectableRows = this.newDataSource.data.filter(
      (row) => !row.isExpansion
    );
    const numSelected = selectableRows.filter((row) => row.selected).length;
    return numSelected > 0 && numSelected < selectableRows.length;
  }

  // masterToggle() {
  //   const selectableRows = this.tableRows.filter((row) => !row.isExpansion);
  //   if (this.isAllSelected()) {
  //     this.selection.clear();
  //   } else {
  //     this.selection.clear();
  //     selectableRows.forEach((row) => this.selection.select(row));
  //   }
  //   this.selectedSubstantiataionRow = this.selection.selected;
  //   // Sync selected property in newDataSource.data
  //   this.newDataSource.data = this.newDataSource.data.map((row) => ({
  //     ...row,
  //     selected: this.selection.isSelected(row),
  //   }));
  //   this.cdr.detectChanges();
  // }

  masterToggle() {
    const selectableRows = this.newDataSource.data.filter(
      (row) => !row.isExpansion
    );

    if (this.isAllSelected()) {
      console.log('inside iff');
      this.selection.clear();
      selectableRows.forEach((row) => {
        row.selected = false;
      });
      console.log(this.newDataSource.data, '1111');
    } else {
      console.log('inside esle');
      this.selection.clear();
      selectableRows.forEach((row) => {
        this.selection.select(row);
        row.selected = true;
      });
      console.log(this.newDataSource.data, '1222');
    }

    this.selectedSubstantiataionRow = this.selection.selected;
    console.log(this.newDataSource.data, 'master toggle');
    this.cdr.detectChanges();
  }

  // toggleRowSelection(row: any) {
  //   this.selection.toggle(row);
  //   // Sync selected property in newDataSource.data
  //   this.newDataSource.data = this.newDataSource.data.map((r) => ({
  //     ...r,
  //     selected: this.selection.isSelected(r),
  //   }));
  //   this.selectedSubstantiataionRow = this.selection.selected;
  //   this.cdr.detectChanges();
  // }
  toggleRowSelection(row) {
    const isSelected = !row.selected;

    // Find and update the row in newDataSource.data
    const slnoStr = String(row.slno).replace(/^0+/, '');
    const foundRow = this.newDataSource.data.find(
      (r) => String(r.slno).replace(/^0+/, '') === slnoStr
    );

    if (foundRow) {
      foundRow.selected = isSelected;
    }

    if (isSelected) {
      this.selection.select(row);
    } else {
      this.selection.deselect(row);
    }

    this.selectedSubstantiataionRow = this.selection.selected;
    this.cdr.detectChanges(); // Ensure UI updates
  }

  // onTextInput(element: any): void {
  //   const current = element.text || '';
  //   const original = element.originalText || ''; // Show icons only if current is not empty and different from original

  //   element.showIcons = current !== '' && current !== original;
  // }

  // clearText(element: any): void {
  //   element.text = '';
  //   element.showIcons = false;
  // }

  // truncate the qualifier column data and statement text column data
  truncateAllQualifiers() {
    this.isTruncated = !this.isTruncated;
    this.tableRows.forEach((element: any) => {
      if (this.isTruncated) {
        if (element.qualifier.length > 25) {
          element.truncatedQualifier =
            element.qualifier.substring(0, 30) + '...';
        } else {
          element.truncatedQualifier = element.qualifier;
        }

        // Truncate text
        if (element.text.length > 25) {
          element.truncatedText = element.text.substring(0, 40) + '...';
        } else {
          element.truncatedText = element.text;
        }
      } else {
        // Revert
        element.truncatedQualifier = element.qualifier;
        element.truncatedText = element.text;
      }
    });
  }

  // Disable the options which is greater than 3 in Manual reason column
  isOptionDisabled(option: string, selected: string[]): boolean {
    return selected.length >= 3 && !selected.includes(option);
  }

  createFilter(): (data: any, filter: string) => boolean {
    return (data, filter): boolean => {
      const searchTerms = JSON.parse(filter);

      const textMatch =
        !searchTerms.text ||
        data.text.toLowerCase().includes(searchTerms.text.toLowerCase());

      const qualifierMatch =
        !searchTerms.qualifier ||
        (Array.isArray(data.qualifier)
          ? data.qualifier
              .join(' ')
              .toLowerCase()
              .includes(searchTerms.qualifier.toLowerCase())
          : (data.qualifier || '')
              .toLowerCase()
              .includes(searchTerms.qualifier.toLowerCase()));

      const marketingMatch =
        !searchTerms.marketing_channels.length ||
        (data.marketing_channels || []).some((channel: string) =>
          searchTerms.marketing_channels.includes(channel)
        );

      // Combine all filters (AND logic)
      return textMatch && qualifierMatch && marketingMatch;
    };
  }

  get isSelectedChanged(): boolean {
    if (this.editIndex >= 0 && this.editItem) {
      const manualTag =
        this.editItem.manual_level.manualTag ||
        this.editItem.manual_risk.manualTag ||
        this.editItem.manual_reason.prediction.find(
          (reason) => reason.manualTag
        );
      return !!manualTag;
    } else {
      return false;
    }
  }

  get isAnyRowChanged(): boolean {
    return this.isReportChanged || this.isSelectedChanged;
  }

  selectDisclaimer(index: number) {
    if (!this.canEdit || index === this.disclaimerIndex) {
      return;
    }
    this.disclaimerIndex = index;
  }

  isDisclaimerSelected(index: number) {
    return this.disclaimerIndex === index;
  }

  get canEdit(): boolean {
    return true;
  }

  /**to save overall result data to veeva  */
  populateOverallResult() {
    let totalRisk;
    if (this.total.risk == '1') {
      totalRisk = 'low';
    } else if (this.total.risk == '2') {
      totalRisk = 'medium';
    } else if (this.total.risk == '3') {
      totalRisk = 'high';
    } else {
      totalRisk = this.total.risk;
    }
  }

  /**to get updated text */
  editableText(event: any, index: number) {
    if (
      this.newDataSource.data[index].oldText !=
      this.newDataSource.data[index].text
    ) {
      console.log('not edited');
      this.newDataSource.data[index].isEdited = true;
    } else {
      console.log('not edited');
      this.newDataSource.data[index].isEdited = false;
    }

    if (event.target.value != null || event.target.value != '') {
      this.isTextEditor[index] = true;
    } else {
      this.isTextEditor[index] = false;
    }
  }

  scrollToBottom() {
    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        if (this.tableContainer?.nativeElement) {
          const container = this.tableContainer.nativeElement;
          container.scrollTop = container.scrollHeight;
        }
      }, 0); // 0ms ensures it runs after DOM update
    });
  }

  onTextInput(element: any): void {
    element.isEdited = element.text !== element.originalText;
  }

  clearText(element: any): void {
    element.text = '';
    element.isEdited = element.text !== element.originalText;
  }

  @ViewChild('exportMenuTrigger') exportMenuTrigger!: MatMenuTrigger;
  @ViewChild('saveAsMenuTrigger') saveAsMenuTrigger!: MatMenuTrigger;

  openMenu(trigger: MatMenuTrigger, event: MouseEvent) {
    event.stopPropagation();
    trigger.openMenu();
  }

  // claimReviewPopup() {}
  //Claim review popup open
  // claimReviewPopup(row: any) {
  //   const dialogRef = this.dialog.open(ClaimsReviewPopupComponent, {
  //     width: '90%',
  //     height: '65%',
  //     disableClose: true,
  //     data: {
  //       project: true,
  //       documentDetails: '',
  //       savedraftData: row, // Pass savedraft_data
  //       currentRowData: row.claimReviewData, // Pass full row data
  //     },
  //   });

  //   // ...existing code...
  //   dialogRef.afterClosed().subscribe((result) => {
  //     // Helper to map popup result to table row structure (similar to ngOnInit)
  //     const mapPopupRow = (popupRow: any) => {
  //       // If substantiations is a string, split and map to objects
  //       let mappedSubstantiations = [];
  //       console.log(popupRow.substantiations, 'popupRow substantiations');
  //       if (typeof popupRow.substantiations === 'string') {
  //         mappedSubstantiations = popupRow.substantiations
  //           .split(',')
  //           .map((s: string) =>
  //             this.mapSubstantiation({ name: s.trim() }, false)
  //           );
  //       } else if (Array.isArray(popupRow.substantiations)) {
  //         mappedSubstantiations = popupRow.substantiations.map((sub: any) =>
  //           this.mapSubstantiation(sub, false)
  //         );
  //       }
  //       console.log(
  //         mappedSubstantiations,
  //         'mappedSubstantiations from popupRow'
  //       );
  //       return {
  //         text: popupRow.statementText || popupRow.text || '',
  //         qualifier: popupRow.qualifier ? [popupRow.qualifier] : [],
  //         marketing_channels: popupRow.marketingChannel
  //           ? popupRow.marketingChannel.split(',').map((s: string) => s.trim())
  //           : [],
  //         support_strategy: popupRow.supportStrategy || '',
  //         substantiations: mappedSubstantiations,
  //         substantiationsString: mappedSubstantiations
  //           .map((x) => x.name)
  //           .join(','),
  //         review_claim: false,
  //         slno: popupRow.slno || popupRow.claim_la_id || popupRow.claim_la_bid,
  //         claim_la_id: popupRow.claim_la_id,
  //         claim_la_bid: popupRow.claim_la_bid,
  //         savedraft_data: popupRow.savedraft_data || [],
  //       };
  //     };

  //     if (result?.action === 'decline' && result.savedInDraft) {
  //       const declinedId =
  //         result.savedInDraft.claim_la_id ||
  //         result.savedInDraft.claim_la_bid ||
  //         result.savedInDraft.slno;
  //       const rowToUpdate = this.tableRowsRaw.find(
  //         (r) =>
  //           r.claim_la_id === declinedId ||
  //           r.claim_la_bid === declinedId ||
  //           r.slno === declinedId
  //       );
  //       if (rowToUpdate) {
  //         const mapped = mapPopupRow(result.savedInDraft);
  //         Object.assign(rowToUpdate, mapped);
  //         this.updateRowSubstantiations(rowToUpdate);
  //       }
  //       this.claimsToReview = this.tableRowsRaw.filter((r) => r.review_claim);
  //       console.log(this.claimsToReview, 'claimsToReview after decline');
  //       this.newDataSource.data = [...this.tableRowsRaw];
  //       console.log(this.newDataSource.data, 'newDataSource after decline');
  //     }
  //     if (result?.action === 'accept' && result.updatedClaim) {
  //       const updatedId =
  //         result.updatedClaim.claim_la_id ||
  //         result.updatedClaim.claim_la_bid ||
  //         result.updatedClaim.slno;
  //       const rowToUpdate = this.tableRowsRaw.find(
  //         (r) =>
  //           r.claim_la_id === updatedId ||
  //           r.claim_la_bid === updatedId ||
  //           r.slno === updatedId
  //       );
  //       if (rowToUpdate) {
  //         const mapped = mapPopupRow(result.updatedClaim);
  //         Object.assign(rowToUpdate, mapped);
  //         this.updateRowSubstantiations(rowToUpdate);
  //       }
  //       this.claimsToReview = this.tableRowsRaw.filter((r) => r.review_claim);
  //       console.log(this.claimsToReview, 'claimsToReview after accept');
  //       this.newDataSource.data = [...this.tableRowsRaw];
  //       console.log(this.newDataSource.data, 'newDataSource after accept');
  //     }
  //   });
  //   // ...existing code...
  // }

  claimReviewPopup(row: any, index: number) {
    console.log(index, 'index offff');
    console.log(row, 'row');
    console.log(this.newDataSource.data, 'newDataSource.data');
    const dialogRef = this.dialog.open(ClaimsReviewPopupComponent, {
      width: '90%',
      height: '65%',
      disableClose: true,
      data: {
        project: true,
        documentDetails: '',
        savedraftData: row,
        currentRowData: row.claimReviewData,
      },
    });

    // Helper to map popup result to table row structure (as per ngOnInit)
    const mapPopupRow = (popupRow: any) => {
      let mappedSubstantiations: any[] = [];
      if (typeof popupRow.substantiations === 'string') {
        mappedSubstantiations = popupRow.substantiations
          .split(',')
          .map((s: string) =>
            this.mapSubstantiation({ name: s.trim() }, false)
          );
      } else if (Array.isArray(popupRow.substantiations)) {
        mappedSubstantiations = popupRow.substantiations.map((sub: any) =>
          this.mapSubstantiation(sub, false)
        );
      }
      console.log(popupRow, 'popupRow from accept and decline');
      return {
        slno: popupRow.slno || '',
        text:
          popupRow.statement || popupRow.statementText || popupRow.text || '',
        originalText:
          popupRow.originalText ||
          popupRow.statement ||
          popupRow.statementText ||
          popupRow.text ||
          '',
        qualifier: popupRow.qualifier ? [popupRow.qualifier] : [],
        originalQualifier: popupRow.originalQualifier
          ? [popupRow.originalQualifier]
          : popupRow.qualifier
          ? [popupRow.qualifier]
          : [],
        marketing_channels: popupRow.marketingChannel
          ? popupRow.marketingChannel.split(',').map((s: string) => s.trim())
          : popupRow.marketing_channels || [],
        support_strategy:
          popupRow.supportStrategy || popupRow.support_strategy || '',
        originalSupportStrategy:
          popupRow.originalSupportStrategy ||
          popupRow.supportStrategy ||
          popupRow.support_strategy ||
          '',
        substantiations: mappedSubstantiations || [],
        substantiationsString: mappedSubstantiations
          .map((x) => x.name)
          .join(','),
        expandedData: popupRow.expandedData || [],
        rowType: popupRow.rowType || '',
        _userAddedSubstantiations: popupRow._userAddedSubstantiations || [],
        apiSubstantiations: mappedSubstantiations || [],
        originalSubstantiations: mappedSubstantiations || [],
        master_exist: popupRow.master_exist ?? false,
        project_exist: popupRow.project_exist ?? false,
        claim_id: popupRow.claim_la_name || popupRow.claim_id || '',
        claim_la_id: popupRow.claim_la_id || popupRow.claim_la_name || '',
        claim_la_bid: popupRow.claim_la_bid || '',
        originalMarketingChannels:
          popupRow.originalMarketingChannels ||
          (popupRow.marketingChannel
            ? popupRow.marketingChannel.split(',').map((s: string) => s.trim())
            : []),
        review_claim: popupRow.review_claim ?? false,
        savedraft_data: popupRow.savedraft_data || [],
        claimReviewData: popupRow.claimReviewData || [],
      };
    };

    dialogRef.afterClosed().subscribe((result) => {
      console.log(result, 'result from accept and decline popup');
      if (!result) return;
      let updatedRowData: any = null;
      if (result.action === 'decline' && result.savedInDraft) {
        updatedRowData = result.savedInDraft;
        console.log(updatedRowData, 'updatedRowData after Decline');
      }
      if (result.action === 'accept' && result.updatedClaim) {
        updatedRowData = result.updatedClaim;
        // If accept, always set _userAddedSubstantiations to empty array
        updatedRowData._userAddedSubstantiations = [];
        console.log(updatedRowData, 'updatedRowData after accepting');
      }
      if (updatedRowData) {
        // Always use slno for updating the row
        const updatedSlno = updatedRowData.slno;
        let rowToUpdate = this.tableRowsRaw.find((r) => r.slno === updatedSlno);

        // Fallback: If not found by slno, try claim_la_id or claim_la_bid for decline flow
        if (!rowToUpdate) {
          const updatedId =
            updatedRowData.claim_la_id ||
            updatedRowData.claim_la_bid ||
            updatedRowData.slno;
          rowToUpdate = this.tableRowsRaw.find(
            (r) =>
              r.claim_la_id === updatedId ||
              r.claim_la_bid === updatedId ||
              r.slno === updatedId
          );
        }

        console.log(rowToUpdate, 'rowToUpdatedata');
        if (rowToUpdate) {
          const mapped = mapPopupRow(updatedRowData);
          // Preserve original slno if missing in mapped
          if (!mapped.slno) {
            mapped.slno = rowToUpdate.slno;
          }
          Object.assign(rowToUpdate, mapped);
          rowToUpdate.review_claim = false; // Hide review icon
          // If you have both local/global data sources, update both if needed
          const localRow = this.localDataSource.find(
            (r) => r.slno === updatedRowData.slno
          );
          if (localRow) {
            localRow.review_claim = false;
          }
          const globalRow = this.globalDataSource.find(
            (r) => r.slno === updatedRowData.slno
          );
          if (globalRow) {
            globalRow.review_claim = false;
          }
          this.updateRowSubstantiations(rowToUpdate);
        }
        this.claimsToReview = this.tableRowsRaw.filter((r) => r.review_claim);
        console.log(this.tableRowsRaw, 'this.tableRowsRaw ');
        this.newDataSource.data = [...this.tableRowsRaw];
        this.newDataSource.data = this.newDataSource.data.map((item) => {
          // Check if apiSubstantiations exists and is an array
          if (Array.isArray(item.apiSubstantiations)) {
            item.apiSubstantiations = item.apiSubstantiations.filter((sub) => {
              // List of fields to check
              const fields = [
                'description',
                'details',
                'document_link',
                'document_name',
                'geography',
                'link',
                'name',
                'substantiation_details',
                'substantiation_id',
                'substantiation_link',
                'subtype',
                'support_strategy',
              ];
              // If all fields are empty, filter out this substantiation
              return fields.some((field) => sub[field] && sub[field] !== '');
            });
            // If all were empty, set to empty array
            if (item.apiSubstantiations.length === 0) {
              item.apiSubstantiations = [];
            }
          }
          return item;
        });
        console.log(
          this.newDataSource.data,
          'this.newDataSource.data from claim '
        );
        this.cdr.detectChanges();
      }
    });
  }

  openLatestUpdatesPopupSubst(rowData: any, index: number): void {
    const dialogRef = this.dialog.open(ClaimsReviewPopupComponent, {
      width: '90%',
      height: '65%',
      disableClose: true,
      data: {
        project: true,
        documentDetails: '',
        savedraftData: rowData,
        currentRowData: rowData.claimReviewData,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (result.removeAlert) {
          rowData.hideAlert = true;
        }
        let updatedData = null;
        if (result.action === 'decline' && result.savedInDraft) {
          updatedData = result.savedInDraft;
        }
        if (result.action === 'accept' && result.updatedClaim) {
          updatedData = result.updatedClaim;
        }
        if (updatedData) {
          this.newDataSource.data[rowData.slno].text =
            updatedData.statementText || updatedData.text || '';
          this.newDataSource.data[rowData.slno].qualifier =
            updatedData.qualifier || [];
          this.newDataSource.data[rowData.slno].marketing_channels =
            updatedData.marketingChannel || [];
          this.newDataSource.data[rowData.slno].support_strategy =
            updatedData.support_strategy || '';
          this.newDataSource.data[rowData.slno].substantiations =
            updatedData.substantiation || '';
          console.log(this.newDataSource.data, 'After updating');
          if (updatedData.updatedData) {
            Object.assign(rowData, updatedData.updatedData);
          }
        }
        this.newDataSource._updateChangeSubscription();
      }
    });
  }

  // To get draft claims count

  removeSubstantiation(element: any, index: number) {
    element.substantiations.splice(index, 1);
    // Update substantiationsString if you use it for display elsewhere
    element.substantiationsString = element.substantiations.join(', ');
    this.tableRows = [...this.tableRows];
  }

  onSubstChipClose(element: any, subst: string, index: number) {}

  getSupportStrategyTooltip(element: any): string {
    // You can format this string as you like
    return `Support Strategy\n${element.support_strategy}`;
  }

  getTableHeight(): string {
    if (!this.isRowVisible) {
      return '80vh';
    } else {
      return '60vh';
      // return '23em';
    }
    //console.log(this.isRowVisible, 'this.isRowVisible');
  }
  getTablePadding(): string {
    if (!this.isRowVisible) {
      return '2.1em';
    } else {
      return '0.5em';
    }
    //console.log(this.isRowVisible, 'this.isRowVisible');
  }

  getSubstantiationTooltip(sub: {
    name: string;
    description?: string;
    details?: string;
    substantiation_id?: string;
  }): string {
    if (!sub || (!sub.substantiation_id && !sub.description)) return '';
    const desc = sub.details ?? '';
    return `${sub.name}\n\n${sub.description || ''}`;
  }

  openSubstantiationLink(link: string, event: MouseEvent) {
    event.stopPropagation(); // Prevent row click/expand, if any
    if (link) {
      window.open(link, '_blank');
    }
  }

  // showTooltip(
  //   event: MouseEvent,
  //   tooltipData: {
  //     name: string;
  //     description?: string;
  //     details?: string;
  //     subtype?: string;
  //     geography?: string;
  //   }
  // ) {
  //   this.closeTooltip();

  //   const tooltipWidth = 200; // px
  //   const offsetX = -Math.round(tooltipWidth * 0.4); // 40% of width to left
  //   const offsetY = 8;

  //   const targetElement = event.target as HTMLElement;
  //   const rect = targetElement.getBoundingClientRect();
  //   const viewportHeight = window.innerHeight;

  //   // Check if there's enough space below the element
  //   const spaceBelow = viewportHeight - rect.bottom;
  //   const showAbove = spaceBelow < 100; // threshold in px

  //   const positionStrategy = this.overlay
  //     .position()
  //     .flexibleConnectedTo(targetElement)
  //     .withPositions([
  //       showAbove
  //         ? {
  //             originX: 'start',
  //             originY: 'top',
  //             overlayX: 'start',
  //             overlayY: 'bottom',
  //             offsetX: offsetX,
  //             offsetY: -offsetY,
  //           }
  //         : {
  //             originX: 'start',
  //             originY: 'bottom',
  //             overlayX: 'start',
  //             overlayY: 'top',
  //             offsetX: offsetX,
  //             offsetY: offsetY,
  //           },
  //     ]);

  //   this.overlayRef = this.overlay.create({
  //     hasBackdrop: false,
  //     positionStrategy,
  //     scrollStrategy: this.overlay.scrollStrategies.reposition(),
  //   });

  //   const tooltipPortal = new ComponentPortal(TooltipComponent, this.vcr);
  //   const tooltipRef = this.overlayRef.attach(tooltipPortal);
  //   tooltipRef.instance.substantiation = tooltipData;
  // }

  // closeTooltip() {
  //   if (this.overlayRef) {
  //     this.overlayRef.dispose();
  //     this.overlayRef = null;
  //   }
  // }

  private tooltipListeners: (() => void)[] = [];
  private tooltipCloseTimeout: any;

  showTooltip(
    event: MouseEvent,
    tooltipData: {
      name: string;
      description?: string;
      details?: string;
      subtype?: string;
      geography?: string;
    }
  ) {
    this.closeTooltip();

    const targetElement = event.target as HTMLElement;
    const tooltipWidth = 200;
    const offsetX = -Math.round(tooltipWidth * 0.4);
    const offsetY = 8;
    const rect = targetElement.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    const spaceBelow = viewportHeight - rect.bottom;
    const showAbove = spaceBelow < 100;

    const positionStrategy = this.overlay
      .position()
      .flexibleConnectedTo(targetElement)
      .withPositions([
        showAbove
          ? {
              originX: 'start',
              originY: 'top',
              overlayX: 'start',
              overlayY: 'bottom',
              offsetX,
              offsetY: -offsetY,
            }
          : {
              originX: 'start',
              originY: 'bottom',
              overlayX: 'start',
              overlayY: 'top',
              offsetX,
              offsetY,
            },
      ]);

    this.overlayRef = this.overlay.create({
      hasBackdrop: false,
      positionStrategy,
      scrollStrategy: this.overlay.scrollStrategies.reposition(),
    });

    const tooltipPortal = new ComponentPortal(TooltipComponent, this.vcr);
    const tooltipRef = this.overlayRef.attach(tooltipPortal);
    tooltipRef.instance.substantiation = tooltipData;

    const tooltipElement = this.overlayRef.overlayElement;

    const cancelClose = () => {
      if (this.tooltipCloseTimeout) {
        clearTimeout(this.tooltipCloseTimeout);
        this.tooltipCloseTimeout = null;
      }
    };

    const scheduleClose = () => {
      this.tooltipCloseTimeout = setTimeout(() => {
        this.closeTooltip();
      }, 300); // delay to allow hover transition
    };

    targetElement.addEventListener('mouseenter', cancelClose);
    targetElement.addEventListener('mouseleave', scheduleClose);
    tooltipElement.addEventListener('mouseenter', cancelClose);
    tooltipElement.addEventListener('mouseleave', scheduleClose);

    this.tooltipListeners = [
      () => targetElement.removeEventListener('mouseenter', cancelClose),
      () => targetElement.removeEventListener('mouseleave', scheduleClose),
      () => tooltipElement.removeEventListener('mouseenter', cancelClose),
      () => tooltipElement.removeEventListener('mouseleave', scheduleClose),
    ];
  }

  closeTooltip() {
    if (this.overlayRef) {
      this.overlayRef.dispose();
      this.overlayRef = null;
    }

    if (this.tooltipCloseTimeout) {
      clearTimeout(this.tooltipCloseTimeout);
      this.tooltipCloseTimeout = null;
    }

    if (this.tooltipListeners) {
      this.tooltipListeners.forEach((remove) => remove());
      this.tooltipListeners = [];
    }
  }

  // /**to get global qualifiers and marketing channels for newly added claim/la*/
  existingQualifierValues: any = [];
  getGlobalQualifiersMarketingChannels(event, index) {
    this.enableDropdowns = true;
    const defaultMarketingChannel =
      this.newDataSource.data[0].marketing_channels;
    // const newQualifiers = this.initialData[0].new_qualifiers;
    const statementText = this.newDataSource.data[index - 1].text;

    //Global duplicate check through API
    // let tableData = [
    //   ...this.newDataSource.data,
    //   ...this.existingDataSource.data,
    // ];
    let tableData = [...this.newDataSource.data];
    const statements: any = [];
    const statementLanguage: any = [];
    tableData.forEach((element) => {
      statements.push(element.text.trim());
      statementLanguage.push(element.statement_language);
    });
    let newRowText: any;
    const duplicateCheckData = {
      text: statements,
      input_language: statementLanguage,
      session_id: sessionStorage.getItem('sessionId'),
      environment: localStorage.getItem('environment'),
    };
    this.loadingService.setLoading(true);
    this.sharedService
      .checkDuplicatesData(duplicateCheckData)
      .subscribe((res: any) => {
        if (res.duplicates.length > 0) {
          this.newDataSource.data[index].selected = false; // to make deleted row's selected attribute to false
          this.newDataSource.data.splice(index, 1); //to remove newly added row if found duplicate

          const finaltext = `Duplicate texts found. 
            
                            '${res.duplicates.join(', ')}'
                            
                            Kindly add a new row again.`;

          const dialogConfig = new MatDialogConfig();
          dialogConfig.disableClose = true;
          (dialogConfig.height = '35%'),
            (dialogConfig.width = '370px'),
            (dialogConfig.data = {
              message: finaltext,
              messageType: 'duplicateVeeva',
              buttons: [{ id: 'OK', text: 'OK' }],
              submitButtonId: 'OK',
              type: PopupType.ERROR,
            } as any);
          this.dialog
            .open(IraAlertPopupComponent, dialogConfig)
            .afterClosed()
            .subscribe((response) => {});
          this.loadingService.setLoading(false);
          // to update newDataSource with latest changes
          this.newDataSource._updateChangeSubscription();
        } else {
          //if no duplicates found, then check whether statement is present Veeva library through API
          const checkExistingData = {
            text: statements,
            input_language: statementLanguage,
            session_id: sessionStorage.getItem('sessionId'),
            environment: localStorage.getItem('environment'),
          };
          this.loadingService.setLoading(true);
          this.sharedService
            .checkExistingVeevaData(checkExistingData)
            .subscribe((res: any) => {
              if (res.result.length > 0) {
                const textData = res.result.map((text) => {
                  const finaltext = `"${text.new}" will be replaced with "${text.existing}" `;
                  return finaltext;
                });
                const dialogConfig = new MatDialogConfig();
                dialogConfig.disableClose = true;
                (dialogConfig.height = '35%'),
                  (dialogConfig.width = '390px'),
                  (dialogConfig.data = {
                    message: `The below statements are already present in the system. Hence, the existing values will be taken forward to the next page

              ${textData}

             `,
                    messageType: 'duplicateVeeva',
                    buttons: [{ id: 'OK', text: 'OK' }],
                    submitButtonId: 'OK',
                    type: PopupType.ERROR,
                  } as any);
                this.dialog
                  .open(IraAlertPopupComponent, dialogConfig)
                  .afterClosed()
                  .subscribe((response) => {
                    this.newDataSource.data[index].text =
                      res.result[0].existing;
                  });
                newRowText = res.result[0].existing;
                this.loadingService.setLoading(false);
              } else {
                newRowText = statementText;
              }
              this.loadingService.setLoading(true);
              //Check Global Marketing Channel and Qualifier
              let allQualifier: any = [];
              const data = {
                session_id: sessionStorage.getItem('sessionId'),
                text: newRowText,
                text_language: this.selectedLanguage,
                environment: localStorage.getItem('environment'),
                project_id: localStorage.getItem('project'),
                product_id: localStorage.getItem('product'),
                geography_id: localStorage.getItem('geography') || '',
                user_security_profile: localStorage.getItem('userRole'),
                project_access: JSON.parse(
                  localStorage.getItem('projectAccessDetails') || ''
                ),
                business_group: localStorage.getItem('businessGroup'),
                user_id: localStorage.getItem('userId'),
              };
              const qualifierArr: any = [];
              this.sharedService
                .checkGlobalClaimLA(data)
                .subscribe((response: any) => {
                  //to set editing status for newly added row
                  // this.newDataSource.data[index].editing_status.claim_order__c =
                  //   response.editing_status?.claim_order__c;
                  // this.newDataSource.data[
                  //   index
                  // ].editing_status.marketing_channels__c =
                  //   response.editing_status?.marketing_channels__c;
                  // this.newDataSource.data[index].editing_status.qualifier__c =
                  //   response.editing_status?.qualifier__c;
                  // this.newDataSource.data[
                  //   index
                  // ].editing_status.statement_text__v =
                  //   response.editing_status?.statement_text__v;

                  this.newDataSource.data[index].isFieldsDisabled = false;
                  this.newDataSource.data[index].isEdited = false;

                  if (response.Qualifier_UI.length > 0) {
                    response.Qualifier_UI.map((result) => {
                      if (result != '<p></p>') {
                        allQualifier.push({
                          type: 'old',
                          text: result,
                          icon: 'fa-robot',
                        });
                      }
                    });
                  }
                  if (this.isFormatted == false) {
                    // if (this.originalReport[0].new_qualifiers.length != 0) {
                    //   this.originalReport[0].new_qualifiers.map((result) => {
                    //     allQualifier.push({
                    //       type: 'new',
                    //       text: result,
                    //       icon: '',
                    //     });
                    //   });
                    // }
                  }
                  // this.selectedQualifiers[index] = allQualifier;
                  this.newDataSource.data[index].allQualifier = allQualifier;
                  this.existingQualifierValues.splice(
                    this.existingQualifierValues.length + 1,
                    0,
                    allQualifier
                  );

                  if (this.isFormatted == true) {
                    if (allQualifier.length > 0) {
                      this.newDataSource.data[index].qualifiers = [
                        allQualifier[0].text,
                      ];
                      this.newDataSource.data[index].existing_qualifier = [
                        allQualifier[0].text,
                      ];
                    } else {
                      this.newDataSource.data[index].qualifiers = [];
                    }
                  }
                  if (response.marketing_channels?.length > 0) {
                    this.newDataSource.data[index].marketing_channels = [
                      ...response.marketing_channels,
                    ];
                    this.newDataSource.data[index].allMarketingChannels = [
                      ...response.marketing_channels,
                    ];
                  } else {
                    this.newDataSource.data[index].marketing_channels = [];
                    this.newDataSource.data[index].allMarketingChannels = [];
                  }

                  if (response.lifecycle?.length > 0) {
                    this.newDataSource.data[index].assessed_state =
                      response.lifecycle_UI[0];
                    this.newDataSource.data[index].assessed_state_backend =
                      response.lifecycle[0];
                  } else {
                    this.newDataSource.data[index].assessed_state = '';
                    this.newDataSource.data[index].assessed_state_backend =
                      'None';
                  }
                  this.loadingService.setLoading(false);
                });
            });
        }
      });
  }
  deleteSubstantiation(subst: any, element: any, substIndex: number): void {
    this.substToDelete = subst;
    this.deleteElement = element;
    this.deleteIndex = substIndex;

    this.dialogRef = this.dialog.open(this.deleteSubstDialog, {
      disableClose: true,
    });

    // this.dialogRef.afterClosed().subscribe((result) => {
    //   if (result === 'confirm') {
    //     // Track deleted substantiations
    //     element._deletedSubstantiationIds =
    //       element._deletedSubstantiationIds || [];
    //     element._deletedSubstantiationIds.push(subst.substantiation_id);

    //     // Remove from substantiations array
    //     element.substantiations.splice(substIndex, 1);
    //     element.substantiationsString = element.substantiations
    //       .map((x: any) => x.name)
    //       .join(',');

    //     // Update expanded map
    //     const updatedExpanded = this.expandedDataMap
    //       .get(element)
    //       ?.filter((s: any) => s.substantiation_id !== subst.substantiation_id);
    //     this.expandedDataMap.set(element, updatedExpanded || []);

    //     //  Ensure consistency across views
    //     this.updateRowSubstantiations(element);

    //     // Refresh filters and UI
    //     this.applyExpandedFilters(element);
    //     this.tableRows = this.getTableRows();
    //     this.cdr.detectChanges();
    //   }
    // });

    this.dialogRef.afterClosed().subscribe((result) => {
      if (result === 'confirm') {
        const shouldDeleteViaAPI =
          // subst.textColorClass === 'text-light-blue' ||
          // (subst.textColorClass === 'text-grey' &&
          //   subst.fromClaimSubst === false &&
          //   (!subst.geography || subst.geography.trim() === ''));
          subst.textColorClass === 'text-blue' ||
          subst.textColorClass === 'text-black';

        if (shouldDeleteViaAPI) {
          // Call API to delete substantiation
          console.log('Deleting substantiation via API', element);
          const payload = {
            session_id: sessionStorage.getItem('sessionId'),
            environment: localStorage.getItem('environment'),
            geography_id: localStorage.getItem('geography') || '',
            claim_la_id: element.claim_la_bid,
            substantiation_id: subst.substantiation_id,
          };
          console.log(payload, 'payload');
          this.substantiationService.removeSubstantiation(payload).subscribe({
            next: () => {
              console.log('Substantiation deleted successfully API');
              this.removeSubstFromRow(subst, element, substIndex);
            },
            error: () => {
              console.error('Failed to delete substantiation from API');
            },
          });
        } else {
          // Just remove locally
          this.removeSubstFromRow(subst, element, substIndex);
        }
      }
    });
  }

  // removeSubstFromRow(subst: any, element: any, substIndex: number): void {
  //   // this.autoSaveSubject.next(); // Resets the timer
  //   element._deletedSubstantiationIds = element._deletedSubstantiationIds || [];
  //   element._deletedSubstantiationIds.push(subst.substantiation_id);

  //   element.substantiations.splice(substIndex, 1);
  //   element.substantiationsString = element.substantiations
  //     .map((x: any) => x.name)
  //     .join(',');

  //   const updatedExpanded = this.expandedDataMap
  //     .get(element)
  //     ?.filter((s: any) => s.substantiation_id !== subst.substantiation_id);
  //   this.expandedDataMap.set(element, updatedExpanded || []);

  //   this.updateRowSubstantiations(element);
  //   this.applyExpandedFilters(element);
  //   this.tableRows = this.getTableRows();
  //   this.cdr.detectChanges();
  // }
  removeSubstFromRow(subst: any, element: any, substIndex: number): void {
    // Track deleted substantiations
    element._deletedSubstantiationIds = element._deletedSubstantiationIds || [];
    element._deletedSubstantiationIds.push(subst.substantiation_id);

    // Remove from all substantiation arrays
    element.substantiations = (element.substantiations || []).filter(
      (s: any) => s.substantiation_id !== subst.substantiation_id
    );
    element.apiSubstantiations = (element.apiSubstantiations || []).filter(
      (s: any) => s.substantiation_id !== subst.substantiation_id
    );
    element.originalSubstantiations = (
      element.originalSubstantiations || []
    ).filter((s: any) => s.substantiation_id !== subst.substantiation_id);
    element._userAddedSubstantiations = (
      element._userAddedSubstantiations || []
    ).filter((s: any) => s.substantiation_id !== subst.substantiation_id);

    element.substantiationsString = (element.substantiations || [])
      .map((x: any) => x.name)
      .join(',');

    const updatedExpanded = (this.expandedDataMap.get(element) || []).filter(
      (s: any) => s.substantiation_id !== subst.substantiation_id
    );
    this.expandedDataMap.set(element, updatedExpanded);

    this.updateRowSubstantiations(element);
    this.applyExpandedFilters(element);
    this.tableRows = this.getTableRows();
    this.cdr.detectChanges();
  }

  closeDialog(result: string) {
    if (this.dialogRef) {
      this.dialogRef.close(result);
    }
  }

  dropTableRow(event: CdkDragDrop<any[]>) {
    // Move in the source data array, not the view
    moveItemInArray(
      this.newDataSource.data,
      event.previousIndex,
      event.currentIndex
    );

    // Let MatTable know data changed
    this.newDataSource._updateChangeSubscription();

    // Rebuild your view (tableRows) if necessary
    this.tableRows = this.getTableRows();
  }

  // Reset ALl func
  // substantiation.component.ts
  resetSubstantiationFields(): void {
    this.textFilter.setValue('');
    this.qualifierFilter.setValue('');
    this.marketingFilter.setValue([]);
    this.substantiationIdFilter.setValue('');
    this.substantiationdescFilter.setValue('');
    this.substantiationGeogeaphyFilter.setValue('');

    //this.selection.clear();
    this.expandedDataMap.clear();
    this.expandedElements.clear();
    this.expandedRowFilters.clear();
    this.expandedRowSearchState.clear();
    //this.isRowVisible = false;

    // for rest table height
    //this.isRowVisible = true;

    this.newDataSource.data.forEach((row) => {
      row.selected = false;
      row.text = row.originalText;
      row.isEdited = false;

      // Reset rich text editor view
      row.richtext = false;

      // Restore only original marketing channels
      row.marketing_channels = row.originalMarketingChannels
        ? [...row.originalMarketingChannels]
        : [];
      console.log(row.originalQualifier, 'row.originalQualifier');
      // Restore original qualifiers if needed
      //row.qualifier = row.originalQualifier ? [...row.originalQualifier] : [];
      row.qualifier = row.originalQualifier
        ? Array.isArray(row.originalQualifier)
          ? [...row.originalQualifier] // Copy the array
          : row.originalQualifier // Retain the string as is
        : Array.isArray(row.qualifier)
        ? []
        : '';
      // Restore original support strategy if needed
      row.support_strategy = row.originalSupportStrategy || '';

      // Restore original substantiations
      row.substantiations = row.originalSubstantiations
        ? [...row.originalSubstantiations]
        : [];
      row.apiSubstantiations = row.originalSubstantiations
        ? [...row.originalSubstantiations]
        : [];
      row._userAddedSubstantiations = [];
      row.substantiationsString = row.originalSubstantiations
        .map((s: any) => s.description || '')
        .join(','); //  Update expanded row data if the row is expanded

      // if (this.expandedDataMap.has(row)) {
      //   this.expandedDataMap.set(row, [...row.originalSubstantiations]);
      // }
      this.expandedDataMap.set(row, [...row.originalSubstantiations]);
      row.isExpanded = false;
    });

    this.tableRows = this.getTableRows();
    this.cdr.detectChanges();
  }

  // Wrap text functionality
  wrapStatementAndQualifierText(): void {
    this.isTruncated = !this.isTruncated;
    // Show loader before wrapping text
    this.loadingService.setLoading(true);
    setTimeout(() => {
      const textareas = document.querySelectorAll(
        'textarea.txt-area-statement, textarea.txt-area-qualifier, textarea.support-strategy-2lines,textarea'
      );
      textareas.forEach((ta: any) => this.autoResize(ta));

      const divs = document.querySelectorAll('.substantiation-chips-area');
      divs.forEach((div: HTMLElement) => this.autoResizeDiv(div));
      // Hide loader after wrapping is done
      this.loadingService.setLoading(false);
    }, 0);
  }

  autoResize(textarea: HTMLTextAreaElement): void {
    if (!this.isTruncated) {
      textarea.style.height = 'auto';
      textarea.style.height = textarea.scrollHeight + 'px';
      textarea.style.overflow = 'hidden';
      textarea.style.resize = 'none';
    } else {
      textarea.style.height = '6vh';
      textarea.style.overflow = 'auto';
      textarea.style.resize = 'none';
    }
  }

  autoResizeDiv(div: HTMLElement): void {
    if (!this.isTruncated) {
      div.style.height = 'auto';
      div.style.height = div.scrollHeight + 'px';
      div.style.overflow = 'hidden';
      div.style.resize = 'none';
    } else {
      div.style.height = '9vh';
      div.style.overflow = 'auto';
      div.style.resize = 'none';
    }
  }

  redirectToResult() {
    this.router.navigate(['result']);
  }

  getSubstantiationDataForConfirmation(): any[] {
    return this.newDataSource.data.map((row, index) => ({
      slno: index + 1,
      text: row.text,
      qualifier: row.qualifier,
      marketingchannel: row.marketing_channels,
      support_strategy: row.support_strategy,
      substantiations: row.substantiations,
      selected: true,
      statement_language: this.selectedLanguage || 'English',
    }));
  }

  // format Qualifire
  formatQualifier() {
    this.isFormatted = true;
    this.newDataSource.data.forEach((element: any) => {
      if (element.allQualifier?.length > 0) {
        element.qualifiers = element.allQualifier.map((q: any) => q.text);
      }
      element.richtext = false;
    });
    this.newDataSource._updateChangeSubscription();
  }
  init: any;
  editorInstance: any;

  /**update added qualifier */
  updateQualifiers(index, content) {
    const contentString = content.toString(); // Convert content to a string

    // Check if contentString is not empty
    if (contentString.trim() !== '') {
      const qualifiers = contentString
        .split('<br> ')
        .map((item) => item.trim());
      this.newDataSource.data[index].qualifiers = qualifiers;
      //this.selectedQualifiersUpdated[index] = qualifiers;
      //this.enteredQualifiers[index] = qualifiers;
    }
  }

  updateEditorQualifierHeight(editor) {
    const editorContainer = editor.getContainer();
    if (!editorContainer) {
      console.error('Editor container is undefined');
      return;
    }
    const width = window.innerWidth;

    // 150% @media screen and (max-width: 1280px)
    if (width <= 1280) {
      console.log('150% height');
      editorContainer.style.height = '11vh';
      //  editorContainer.style.width = '45vw';
    }
    // 1366 × 768 resolution
    else if (width <= 1366) {
      console.log('1366 height');
      editorContainer.style.height = '12vh';
      // editorContainer.style.width = '45vw';
    }
    // 125%
    else if (width <= 1536) {
      console.log('125% height');
      editorContainer.style.height = '19vh';
      editorContainer.style.width = '45vw';
    }
    // **Exclude 1920px screens before checking 2560px**
    else if (width > 1920 && width <= 2560) {
      console.log('1920 height');
      editorContainer.style.height = '18vh';
      //editorContainer.style.width = '45vw';
    }
    // 3840+ resolution
    else if (width >= 3840) {
      console.log('3840 height');
      editorContainer.style.height = '17vh';
      editorContainer.style.width = '45vw';
    }
    // **Default case for 1920 × 1080** 100%
    else {
      console.log('100% height');
      editorContainer.style.height = '20vh';
      editorContainer.style.width = '46vw';
    }
  }

  // init: any;
  richtext = false;

  enableEditor(element: any, index: number) {
    console.log(index, 'index');
    console.log(element, 'element');

    // Reset richtext for all rows
    this.newDataSource.data.forEach((el) => {
      el.richtext = false;
    });

    // Enable richtext only for the clicked row
    element.richtext = true;

    // Initialize the editor with the content from the clicked element
    this.init = {
      setup: (editor) => {
        // editor.on('init', () => {
        //   const content = element.qualifiers || '';
        //   editor.setContent(content.replace(/,/g, '<br>'));
        // });
        editor.on('init', () => {
          let content = '';
          if (Array.isArray(element.support_strategy)) {
            content = element.support_strategy.join(', ');
          } else if (typeof element.support_strategy === 'string') {
            content = element.qualifier.trim();
          }
          editor.setContent(content.replace(/,/g, '<br>'));
        });
      },
      extended_valid_elements: 'b,i',
      formats: {
        bold: { inline: 'b' },
        italic: { inline: 'i' },
        underline: { inline: 'u' },
      },

      style_formats: [
        {
          title: 'Orange Numbered List',
          selector: 'ol',
          styles: {
            color: '#D35400',
            'list-style-type': 'decimal',
            'font-style': 'italic',
          },
        },
        {
          title: 'Blue Square Bullets',
          selector: 'ul',
          styles: {
            color: '#2A5DB0',
            'list-style-type': 'square',
            'font-weight': 'bold',
          },
        },
      ],

      height: 100,
      branding: false,
      menubar: false,
      resize: false,
      statusbar: false,
      font_family_formats: 'Unilever Shilling = unilever shilling;',
      content_style: `
    @import url(https://db.onlinewebfonts.com/c/234d23830d4b4e8a08fdf491981b4b1f?family=Unilever+Shilling);
    body {
      font-size: 10px;
      color: #49526E;
      font-family: "Unilever Shilling";
      margin-left: 5px;
      line-height: 1.2;
      margin-top: -9px;
    }

    ul {
      list-style-type: square;
      padding-left: 20px;
      color: #2A5DB0;
      font-weight: bold;
    }

    ol {
      list-style-type: decimal;
      padding-left: 20px;
      color: #D35400;
      font-style: italic;
    }

    li {
      margin-bottom: 4px;
    }

    @media (min-width: 2560px) { body { font-size: 25px; } }
    @media (min-width: 3840px) { body { font-size: 30px; } }
  `,
      outputFormat: 'html',
      plugins: 'fullscreen lists',
      toolbar: `
        bold italic underline fullscreen | formatselect | undo redo |
        alignleft aligncenter alignright alignjustify |
        bullist numlist outdent indent | removeformat
      `,
    };
  }

  async saveClaims(payloadData) {
    console.log(payloadData, 'payloadData');
    const originalData = this.checkdatachaged;
    const currentData = this.newDataSource.data;
    this.loadingService.setLoading(true);
    // Fields to check for changes
    const fieldsToCheck = [
      'text',
      'support_strategy',
      'substantiations',
      'qualifier',
      'marketing_channels',
    ];

    const changedRows = currentData.filter((currentRow: any, index: number) => {
      const originalRow = originalData[index];

      // Compare specified fields
      return fieldsToCheck.some((field) => {
        if (
          Array.isArray(currentRow[field]) &&
          Array.isArray(originalRow[field])
        ) {
          // Compare arrays
          return (
            JSON.stringify(currentRow[field]) !==
            JSON.stringify(originalRow[field])
          );
        } else {
          // Compare primitive values
          return currentRow[field] !== originalRow[field];
        }
      });
    });

    console.log(changedRows, 'changedRows');
    // Assign originalData after processing the API response
    this.originalData = [...this.newDataSource.data];
    console.log(this.originalData, 'this.originalData ');

    // this.newDataSource.data = this.newDataSource.data.map((row) => ({
    //   ...row,
    //   selected: this.selection.isSelected(row),
    // }));
    console.log(
      this.newDataSource.data,
      'this.newDataSource.data after adding selection'
    );

    // Filter only selected rows
    console.log(this.selection, 'this.selection');
    //const selectedRows = this.selection.selected;
    const selectedRows = this.newDataSource.data.filter(
      (row) => row.selected === true
    );
    console.log(selectedRows, 'selectedRows');
    if (!selectedRows || selectedRows.length === 0) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true;
      (dialogConfig.height = '180px'),
        (dialogConfig.width = '400px'),
        (dialogConfig.data = {
          message: `Please select atleast one checkbox`,
          // lowerText: `Please select atleast one checkbox`,
          buttons: [{ id: 'OK', text: 'COMMON.OK' }],
          submitButtonId: 'OK',
          type: PopupType.ERROR,
          messageType: 'duplicateVeeva',
        } as any);
      this.dialog
        .open(IraAlertPopupComponent, dialogConfig)
        .afterClosed()
        .subscribe((response) => {});
      this.loadingService.setLoading(false);
      return;
    }

    // Add claimsToReview check
    if (this.claimsToReview && this.claimsToReview.length > 0) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true;
      dialogConfig.height = '180px';
      dialogConfig.width = '400px';
      dialogConfig.data = {
        message: `Please review the claims before proceeding.`,
        buttons: [{ id: 'OK', text: 'COMMON.OK' }],
        submitButtonId: 'OK',
        type: PopupType.ERROR,
        messageType: 'duplicateVeeva',
      } as any;
      this.dialog
        .open(IraAlertPopupComponent, dialogConfig)
        .afterClosed()
        .subscribe(() => {});
      this.loadingService.setLoading(false);
      return;
    }

    // Map selectedRows to include claim_la_id for each record
    const mappedRows = this.originalData.map((row: any) => ({
      ...row, // Spread the original row properties
      claim_la_id: row.claim_la_bid || '', // Include claim_la_id or default to ''
    }));
    // console.log(mappedRows, 'mappedRows');
    // console.log(changedRows, 'changedRows');
    console.log(this.resultnewDataSource, 'this.resultnewDataSource');
    // to remove qualifiers form control property from Result Array
    const resultPageData = this.resultnewDataSource.filter((obj) => {
      delete obj.qualifiersFormControl;
      return obj;
    });
    await this.saveDraftSubstantiation(payloadData.fileDetails);
    this.router.navigate(['/substantiation-confirmation'], {
      state: {
        data: selectedRows,
        selectedData: changedRows,
        subcomp: true,
        allRows: this.newDataSource.data, // <-- Add this line
        responseData: payloadData.responseData,
        documentData: payloadData.responseData[0].fileBase64,
        replaceUrl: true,
        fileDetails: payloadData.fileDetails,
        previewMarketingChannels: payloadData.previewMarketingChannels,
        resultData: resultPageData,
        selectedView: this.selectedView,
        routeFrom: this.routeFrom,
      },
    });
    this.loadingService.setLoading(false);
  }

  fileType: any;
  fileDetails: any;
  getImageDetails(file: File): Promise<string> {
    return Converters.toBase64(file);
  }
  // save Draft function
  fileDtl: any;
  saveDraftSubstantiation(values, event?: any) {
    console.log(this.fileDetailsSub, 'ABAAAAA');
    console.log(values, 'this.fileDetails');
    console.log(event, 'event');
    this.fileDetails = values;
    this.fileDtl = {
      lastModified: values?.lastModified,
      lastModifiedDate: values?.lastModifiedDate,
      name: values?.name,
      size: values?.size,
      type: values?.type,
      webkitRelativePath: values?.webkitRelativePath,
    };
    console.log(this.fileDetails, 'this.fileDetails');
    return new Promise(async (resolve, reject) => {
      try {
        this.fileType = localStorage.getItem('fileType');
        let fileInfo: any;
        console.log('fileType', this.fileType);
        console.log(this.routeFrom, 'Route from Save Draft');
        // localStorage.removeItem('routeFrom');
        // localStorage.setItem('routeFrom', 'editClaims');
        //this.fileType = 'image/jpeg';
        if (
          !this.fileType ||
          this.fileType == 0 ||
          !this.fileDetails ||
          this.routeFrom === 'editClaims'
        ) {
          console.log('inside file type');
          fileInfo = '';
        } else {
          const fileBase64 = await this.getImageDetails(this.fileDetails);
          fileInfo = fileBase64;
        }

        const cleanClaims = Converters.sanitizeObject([
          //...this.existingDataSource.data,
          ...this.newDataSource.data,
        ]);
        console.log('cleanClaims', cleanClaims);
        // const mappedData = this.newDataSource.data.map((row: any) => ({
        //   ...row,

        //   // save draft isue due to this claim la id and name
        //   claim_la_name: row.claim_la_name,
        //   claim_la_bid: row.claim_la_bid,
        //   support_strategy_rich: row.support_strategy,
        //   statement: row.text,
        //   // Optionally remove the old keys if you don't want them:
        //   // Remove the old keys if needed:
        //   // Remove claim_id, claim_la_id, support_strategy, text
        //   // ...Object.fromEntries(Object.entries(row).filter(([k]) => !['claim_id', 'claim_la_id', 'support_strategy', 'text'].includes(k)))
        // }));

        const mappedData = this.newDataSource.data.map((row: any) => {
          const { claimReviewData, ...rest } = row; // Remove claimReviewData to avoid circular reference
          return {
            ...rest,
            claim_la_name: row.claim_la_name,
            claim_la_bid: row.claim_la_bid,
            claim_la_id: row.claim_la_id || '',
            support_strategy_rich: row.support_strategy,
            statement: row.text,
          };
        });
        console.log('mappedData', mappedData);
        console.log(this.routeFrom, 'Route from Save Draft');

        // Handle the result from the dialog
        const payloadData = {
          Userid: localStorage.getItem('userId'),
          Project: localStorage.getItem('project'),
          ProjectName: localStorage.getItem('projectName'),
          Product: localStorage.getItem('product'),
          ProductName: localStorage.getItem('productName'),
          Geography: localStorage.getItem('geography'),
          GeographyName: localStorage.getItem('geographyName'),
          Language: localStorage.getItem('language'),
          session_id: sessionStorage.getItem('sessionId'),
          environment: localStorage.getItem('environment'),
          AssetBytes: fileInfo,
          // Page: 'Substantiation',
          Page:
            this.routeFrom === 'editClaims' ||
            localStorage.getItem('routeFrom') === 'subEdit'
              ? 'Sub_editclaims'
              : 'Substantiation',
          Json: {
            mappedData,
            businessGroup: localStorage.getItem('businessGroup'),
            category: localStorage.getItem('category'),
            docInfo: this.docData || { currentPage: {}, document: {} },
            fileDetails: this.fileDtl,
            isAssetExistInVeeva: localStorage.getItem('veevaAssetId')
              ? true
              : false,
            existingDocumentId: localStorage.getItem('veevaAssetId')
              ? localStorage.getItem('veevaAssetId')
              : '',
          },

          //Json: this.newDataSource.data,
          //{
          //   claims_la: this.newDataSource.data,
          //   // fileBase64: this.originalReport[0].fileBase64,
          //   // new_qualifiers: this.originalReport[0].new_qualifiers,
          //   // new_marketing_channels:
          //   //   this.originalReport[0].new_marketing_channels,
          //   // iRA_button: this.originalReport[0].iRA_button,
          // },
        };
        console.log(payloadData, 'save draft payload data');

        this.sharedService.saveDraftData(payloadData).subscribe({
          next: (response: any) => {
            resolve(response);
            console.log(response, 'response from save draft');
            if (event && response.Status == 'Success') {
              console.log(response, ' response from success');
              this.messageService.add({
                severity: 'success',
                summary: '',
                detail: 'Draft data saved successfully',
                key: 'br',
                life: 5000,
              });
            } else if (event && response.Status == 'Failure') {
              console.log(response, ' response from Failure');
              this.messageService.add({
                severity: 'error',
                summary: '',
                detail: 'Draft data failed to save',
                key: 'br',
                life: 5000,
              });
            }
          },
          error: (error) => {
            console.log('catch error');
            reject(error);
          },
        });
      } catch (err) {
        console.log('catch error');
        reject(err);
      }
    });
  }
  sanitizeHTML1(content: any): any {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = content;
    return tempDiv.textContent || tempDiv.innerText || '';
  }

  @HostListener('document:click', ['$event'])
  handleClickOutside(event: MouseEvent) {
    const clickedInsideEditor = (event.target as HTMLElement).closest('editor');
    const clickedInsideTextarea = (event.target as HTMLElement).closest(
      'textarea'
    );

    if (!clickedInsideEditor && !clickedInsideTextarea) {
      this.newDataSource.data.forEach((value) => {
        if (value.isSupportStrategyEdited) {
          // Restore wrap text state if it was in wrap mode before switching to rich text
          if (value.wasInWrapMode) {
            this.isTruncated = false;
            // Trigger the wrap text functionality to ensure proper display
            setTimeout(() => {
              const textareas = document.querySelectorAll(
                'textarea.txt-area-statement, textarea.txt-area-qualifier, textarea.support-strategy-2lines, textarea.support-strategy-edit'
              );
              textareas.forEach((ta: any) => this.autoResize(ta));

              const divs = document.querySelectorAll(
                '.substantiation-chips-area'
              );
              divs.forEach((div: HTMLElement) => this.autoResizeDiv(div));
            }, 0);
          }
        }
        value.isSupportStrategyEdited = false;
      });
    }
  }

  enableSupportStrategyEditor(element: any) {
    // Store current wrap text state before switching to rich text
    element.wasInWrapMode = !this.isTruncated;
    element.isSupportStrategyEdited = true;
    this.closeTooltip();
    this.autoSaveSubject.next();
    //   this.init = {
    //     setup: (editor) => {
    //       // editor.on('init', () => {
    //       //   const content = element.qualifiers || '';
    //       //   editor.setContent(content.replace(/,/g, '<br>'));
    //       // });
    //       editor.on('init', () => {
    //         let content = '';
    //         if (Array.isArray(element.support_strategy)) {
    //           content = element.support_strategy.join(', ');
    //         } else if (typeof element.support_strategy === 'string') {
    //           content = element.support_strategy.trim();
    //         }
    //         editor.setContent(content.replace(/,/g, '<br>'));
    //       });
    //     },
    //     extended_valid_elements: 'b,i',
    //     formats: {
    //       bold: { inline: 'b' },
    //       italic: { inline: 'i' },
    //       underline: { inline: 'u' },
    //     },
    //     style_formats: [
    //       {
    //         title: 'Orange Numbered List',
    //         selector: 'ol',
    //         styles: {
    //           color: '#D35400',
    //           'list-style-type': 'decimal',
    //           'font-style': 'italic',
    //         },
    //       },
    //       {
    //         title: 'Blue Square Bullets',
    //         selector: 'ul',
    //         styles: {
    //           color: '#2A5DB0',
    //           'list-style-type': 'square',
    //           'font-weight': 'bold',
    //         },
    //       },
    //     ],

    //     height: 100,
    //     branding: false,
    //     menubar: false,
    //     resize: false,
    //     statusbar: false,
    //     font_family_formats: 'Unilever Shilling = unilever shilling;',
    //     content_style: `
    //   @import url(https://db.onlinewebfonts.com/c/234d23830d4b4e8a08fdf491981b4b1f?family=Unilever+Shilling);
    //   body {
    //     font-size: 10px;
    //     color: #49526E;
    //     font-family: "Unilever Shilling";
    //     margin-left: 5px;
    //     line-height: 1.2;
    //     margin-top: -9px;
    //   }

    //   ul {
    //     list-style-type: square;
    //     padding-left: 20px;
    //     color: #2A5DB0;
    //     font-weight: bold;
    //   }

    //   ol {
    //     list-style-type: decimal;
    //     padding-left: 20px;
    //     color: #D35400;
    //     font-style: italic;
    //   }

    //   li {
    //     margin-bottom: 4px;
    //   }

    //   @media (min-width: 2560px) { body { font-size: 25px; } }
    //   @media (min-width: 3840px) { body { font-size: 30px; } }
    // `,
    //     outputFormat: 'html',
    //     plugins: 'fullscreen lists',
    //     toolbar: `
    //       bold italic underline fullscreen | formatselect | undo redo |
    //       alignleft aligncenter alignright alignjustify |
    //       bullist numlist outdent indent | removeformat
    //     `,
    //   };
    this.init = {
      setup: (editor) => {
        editor.on('init', () => {
          let content = '';
          if (Array.isArray(element.support_strategy)) {
            content = element.support_strategy.join(', ');
          } else if (typeof element.support_strategy === 'string') {
            content = element.support_strategy.trim();
          }
          editor.setContent(content.replace(/,/g, '<br>'));
        });
      },
      extended_valid_elements: 'b,i,u,strike,sup,sub,a[href|target],blockquote',
      formats: {
        bold: { inline: 'b' },
        italic: { inline: 'i' },
        underline: { inline: 'u' },
        strikethrough: { inline: 'strike' },
        superscript: { inline: 'sup' },
        subscript: { inline: 'sub' },
      },
      style_formats: [
        {
          title: 'Orange Numbered List',
          selector: 'ol',
          styles: {
            color: '#D35400',
            'list-style-type': 'decimal',
            'font-style': 'italic',
          },
        },
        {
          title: 'Blue Square Bullets',
          selector: 'ul',
          styles: {
            color: '#2A5DB0',
            'list-style-type': 'square',
            'font-weight': 'bold',
          },
        },
      ],
      height: 100,
      branding: false,
      menubar: false,
      resize: false,
      statusbar: false,
      font_family_formats: `
    Unilever Shilling=Unilever Shilling;
    Arial=arial,helvetica,sans-serif;
    Courier New=courier new,courier,monospace;
    Georgia=georgia,palatino;
    Times New Roman=times new roman,times;
    Verdana=verdana,geneva;
  `,
      font_size_formats: '8px 10px 12px 14px 16px 18px 24px 36px',
      content_style: `
    @import url(https://db.onlinewebfonts.com/c/234d23830d4b4e8a08fdf491981b4b1f?family=Unilever+Shilling);
    body {
      font-size: 10px;
      color: #49526E;
      font-family: "Unilever Shilling";
      margin-left: 5px;
      line-height: 1.2;
      margin-top: -9px;
    }

    

    @media (min-width: 2560px) { body { font-size: 25px; } }
    @media (min-width: 3840px) { body { font-size: 30px; } }
  `,

      // ul {
      //     list-style-type: circle;
      //     padding-left: 20px;
      //     color: #49526E;
      //     font-weight: bold;
      //   }

      //   ol {
      //     list-style-type: decimal;
      //     padding-left: 20px;
      //    color: #49526E;
      //     font-style: italic;
      //   }

      //   li {
      //     margin-bottom: 4px;
      //   }
      outputFormat: 'html',
      plugins: 'fullscreen lists link charmap textcolor',
      //     toolbar: `
      //   styleselect fontselect fontsizeselect | bold italic underline strikethrough superscript subscript |
      //   forecolor backcolor | blockquote charmap link fullscreen |
      //   formatselect undo redo | alignleft aligncenter alignright alignjustify |
      //   bullist numlist outdent indent | removeformat
      // `,

      // toolbar_mode: 'sliding', // or 'floating'
      toolbar: `
   bold italic underline fullscreen  | styleselect fontselect fontsizeselect |
  forecolor backcolor | strikethrough superscript subscript |
  alignleft aligncenter alignright alignjustify |
  bullist numlist outdent indent blockquote |
  link charmap removeformat undo redo
`,
    };
  }

  disableSupportStrategyEditor(element: any) {
    // Restore wrap text state if it was in wrap mode before switching to rich text
    if (element.wasInWrapMode) {
      this.isTruncated = false;
      // Trigger the wrap text functionality to ensure proper display
      setTimeout(() => {
        const textareas = document.querySelectorAll(
          'textarea.txt-area-statement, textarea.txt-area-qualifier, textarea.support-strategy-2lines, textarea.support-strategy-edit'
        );
        textareas.forEach((ta: any) => this.autoResize(ta));

        const divs = document.querySelectorAll('.substantiation-chips-area');
        divs.forEach((div: HTMLElement) => this.autoResizeDiv(div));
      }, 0);
    }
    element.isSupportStrategyEdited = false;
  }

  // before sonar
  // stripHtmlTags(html: string): string {
  //   if (!html) return '';
  //   return html
  //     .replace(/<[^>]*>/g, '')
  //     .replace(/\s+/g, ' ')
  //     .trim();
  // }

  // After SOnar
  stripHtmlTags(html: string): string {
    if (!html) return '';
    // Use a safer regex for HTML tag removal (no nested angle brackets)
    return html
      .replace(/<\/?[\w\s="/.':;#-\/]+>/gi, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  isClaimStateRestricted(state: string): boolean {
    return [
      'not_pursued_state__c',
      'cancelled_state__c',
      'obsolete_state__c',
    ].includes(state);
  }

  // Add ngOnDestroy method
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.autoSaveSubject.complete(); // Also complete the autoSaveSubject
  }
}

export interface PeriodicElement {
  slno: any;
  text: string;
  qualifier: string[];
  marketing_channels: string[];
  support_strategy: string;
  substantiations: string[];
  icon?: any;
  expand?: any;
}
